import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_CaAsamAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_CaAsamAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <h2> PRESENTING PROBLEM</h2>

                <p className='w-750'>
                    <b> What led you to come in here today? What do you need help with? (symptoms functioning ability, precipitating event)</b>
                    <span className='eleHeader'> Presenting problem</span>
                    <span className='small'> (what brought you in today?):</span>
                    <textarea id='txtPresentingproblem' name='txtPresentingproblem' className='add-only'></textarea>

                    <span className='eleHeader'>What does client hope to get from treatment? (anticipated outcome) </span>
                    <textarea id='txttreatment' name='txttreatment' className='add-only'></textarea>

                    <span className='eleHeader'>How severe, on a scale of 1 - 10 (with 10 being the most severe), do you rate your child's presenting problem? </span>
                    <textarea id='txtpresentingproblem' name='txtpresentingproblem' className='add-only'></textarea>

                    <span className='eleHeader'>Additional Information:  </span>
                    <textarea id='txtInformation' name='txtInformation' className='add-only'></textarea>
                </p>

                <h2>HOUSING/FAMILY COMPOSITION</h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Current living arrangement:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtlivingarrangement_1' name='txtlivingarrangement_1' className='add-only' value='Stable' />Stable </td>
                        <td className='w-187'><input type='checkbox' id='txtlivingarrangement_2' name='txtlivingarrangement_2' className='add-only' value='Unstable' />Unstable </td>
                        <td className='w-300'><input type='checkbox' id='txtlivingarrangement_3' name='txtlivingarrangement_3' className='add-only' value='Experiencing Homelessness' />Experiencing Homelessness  </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Please choose the one that best describes the current housing arrangement for this child: </span>
                    <textarea id='txtpresentingproblem' name='txtpresentingproblem' className='add-only'></textarea>

                    <span className='eleHeader'>How long has this child lived in the current living situation? </span>
                    <textarea id='txtcurrentliving' name='txtcurrentliving' className='add-only'></textarea>

                    <span className='eleHeader'>Any concerns/problems with this living arrangement?</span>
                    <textarea id='txtlivingarrangement' name='txtlivingarrangement' className='add-only'></textarea>

                    <span className='eleHeader'>How many times has the child moved in the past two years? Why?</span>
                    <textarea id='txtchildmoved' name='txtchildmoved' className='add-only'></textarea>

                    <span className='eleHeader'>What else do you think is important for us to understand about your housing/living situation?</span>
                    <textarea id='txtlivingsituation' name='txtlivingsituation' className='add-only'></textarea>

                    <span className='eleHeader'>Additional information: </span>
                    <textarea id='txtinformation' name='txtinformation' className='add-only'></textarea>

                    <span className='eleHeader'>Who lives in your home? </span>
                    <textarea id='txtlivesinyourhome' name='txtlivesinyourhome' className='add-only'></textarea>
                </p>
                <h2>Family Composition</h2>
                <table>
                    <tr>
                        <td className='w-180'> <span className='eleHeader'>Last Name</span> </td>
                        <td className='w-180'> <span className='eleHeader'>First name</span> </td>
                        <td className='w-50'> <span className='eleHeader'>Age</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Relationship to client</span> </td>
                        <td className='w-140'> <span className='eleHeader'>Living in home?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-180'> <input type='text' id='txtLastName_1' name='txtLastName_1' className='add-only' /> </td>
                        <td className='w-180'> <input type='text' id='txtFirstname_1' name='txtFirstname_1' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAge_1' name='txtAge_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationshiptoclient_1' name='txtRelationshiptoclient_1' className='add-only' /> </td>
                        <td className='w-70'> <input type='radio' id='rbLivinginhome_1Yes' name='rbLivinginhome_1' className='add-only' value='Yes' />Yes </td>
                        <td className='w-70'><input type='radio' id='rbLivinginhome_1No' name='rbLivinginhome_1' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-180'> <input type='text' id='txtLastName_2' name='txtLastName_2' className='add-only' /> </td>
                        <td className='w-180'> <input type='text' id='txtFirstname_2' name='txtFirstname_2' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAge_2' name='txtAge_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationshiptoclient_2' name='txtRelationshiptoclient_2' className='add-only' /> </td>
                        <td className='w-70'> <input type='radio' id='rbLivinginhome_2Yes' name='rbLivinginhome_2' className='add-only' value='Yes' />Yes </td>
                        <td className='w-70'><input type='radio' id='rbLivinginhome_2No' name='rbLivinginhome_2' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-180'> <input type='text' id='txtLastName_3' name='txtLastName_3' className='add-only' /> </td>
                        <td className='w-180'> <input type='text' id='txtFirstname_3' name='txtFirstname_3' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAge_3' name='txtAge_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationshiptoclient_3' name='txtRelationshiptoclient_3' className='add-only' /> </td>
                        <td className='w-70'> <input type='radio' id='rbLivinginhome_3Yes' name='rbLivinginhome_3' className='add-only' value='Yes' />Yes </td>
                        <td className='w-70'><input type='radio' id='rbLivinginhome_3No' name='rbLivinginhome_3' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-180'> <input type='text' id='txtLastName_4' name='txtLastName_4' className='add-only' /> </td>
                        <td className='w-180'> <input type='text' id='txtFirstname_4' name='txtFirstname_4' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAge_4' name='txtAge_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationshiptoclient_4' name='txtRelationshiptoclient_4' className='add-only' /> </td>
                        <td className='w-70'> <input type='radio' id='rbLivinginhome_4Yes' name='rbLivinginhome_4' className='add-only' value='Yes' />Yes </td>
                        <td className='w-70'><input type='radio' id='rbLivinginhome_4No' name='rbLivinginhome_4' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-180'> <input type='text' id='txtLastName_5' name='txtLastName_5' className='add-only' /> </td>
                        <td className='w-180'> <input type='text' id='txtFirstname_5' name='txtFirstname_5' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAge_5' name='txtAge_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationshiptoclient_5' name='txtRelationshiptoclient_5' className='add-only' /> </td>
                        <td className='w-70'> <input type='radio' id='rbLivinginhome_5Yes' name='rbLivinginhome_5' className='add-only' value='Yes' />Yes </td>
                        <td className='w-70'><input type='radio' id='rbLivinginhome_5No' name='rbLivinginhome_5' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-180'> <input type='text' id='txtLastName_6' name='txtLastName_6' className='add-only' /> </td>
                        <td className='w-180'> <input type='text' id='txtFirstname_6' name='txtFirstname_6' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAge_6' name='txtAge_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationshiptoclient_6' name='txtRelationshiptoclient_6' className='add-only' /> </td>
                        <td className='w-70'> <input type='radio' id='rbLivinginhome_6Yes' name='rbLivinginhome_6' className='add-only' value='Yes' />Yes </td>
                        <td className='w-70'><input type='radio' id='rbLivinginhome_6No' name='rbLivinginhome_6' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-180'> <input type='text' id='txtLastName_7' name='txtLastName_7' className='add-only' /> </td>
                        <td className='w-180'> <input type='text' id='txtFirstname_7' name='txtFirstname_7' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAge_7' name='txtAge_7' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationshiptoclient_7' name='txtRelationshiptoclient_7' className='add-only' /> </td>
                        <td className='w-70'> <input type='radio' id='rbLivinginhome_7Yes' name='rbLivinginhome_7' className='add-only' value='Yes' />Yes </td>
                        <td className='w-70'><input type='radio' id='rbLivinginhome_7No' name='rbLivinginhome_7' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-180'> <input type='text' id='txtLastName_8' name='txtLastName_8' className='add-only' /> </td>
                        <td className='w-180'> <input type='text' id='txtFirstname_8' name='txtFirstname_8' className='add-only' /> </td>
                        <td className='w-50'> <input type='text' id='txtAge_8' name='txtAge_8' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationshiptoclient_8' name='txtRelationshiptoclient_8' className='add-only' /> </td>
                        <td className='w-70'> <input type='radio' id='rbLivinginhome_8Yes' name='rbLivinginhome_8' className='add-only' value='Yes' />Yes </td>
                        <td className='w-70'><input type='radio' id='rbLivinginhome_8No' name='rbLivinginhome_8' className='add-only' value='No' /> No </td>
                    </tr>


                </table>



                <p>
                    <span className='eleHeader'>Additional information: </span>
                    <textarea id='txtAdditionalinfo' name='txtAdditionalinfo' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Current family dynamics</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='small'> (in client's opinion):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_1' name='txtCurrentfamily_1' className='add-only' value='Chaotic' />Chaotic  </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_2' name='txtCurrentfamily_2' className='add-only' value='Flexible' /> Flexible  </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_3' name='txtCurrentfamily_3' className='add-only' value='Structured' /> Structured  </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_4' name='txtCurrentfamily_4' className='add-only' value='Rigid' /> Rigid </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_5' name='txtCurrentfamily_5' className='add-only' value='Enmeshed' /> Enmeshed </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_6' name='txtCurrentfamily_6' className='add-only' value='Closed' /> Closed    </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_7' name='txtCurrentfamily_7' className='add-only' value='Separate/independent ' /> Separate/independent  </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_8' name='txtCurrentfamily_8' className='add-only' value='Distant/engaged' />Distant/engaged </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_9' name='txtCurrentfamily_9' className='add-only' value='Supportive' />Supportive </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_10' name='txtCurrentfamily_10' className='add-only' value='Appropriate roles and boundaries  ' /> Appropriate roles and boundaries  </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_11' name='txtCurrentfamily_11' className='add-only' value='Seeks outside support or help' /> Seeks outside support or help  </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_12' name='txtCurrentfamily_12' className='add-only' value='Loving' />Loving  </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_13' name='txtCurrentfamily_13' className='add-only' value='Role reversals' />Role reversals</td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_14' name='txtCurrentfamily_14' className='add-only' value='Diffuse boundaries/boundary violations ' />Diffuse boundaries/boundary violations </td>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_15' name='txtCurrentfamily_15' className='add-only' value='Difficulty with life cycle changes' /> Difficulty with life cycle changes </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtCurrentfamily_16' name='txtCurrentfamily_16' className='add-only' value='Other:' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtOthers_1' name='txtOthers_1' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information:</span>
                    <textarea id='txtAdditionalinformation_1' name='txtAdditionalinformation_1' className='add-only'></textarea>

                    <span className='eleHeader'>Who has physical custody of the client? </span>
                    <textarea id='txtphysicalcustody' name='txtphysicalcustody' className='add-only'></textarea>

                    <span className='eleHeader'>Who has legal custody of the client?  </span>
                    <textarea id='txtlegalcustody' name='txtlegalcustody' className='add-only'></textarea>

                    <span className='eleHeader'>Special circumstances (DCFS/grandparents, etc.):</span>
                    <textarea id='txtSpecialcircumstances' name='txtSpecialcircumstances' className='add-only'></textarea>

                    <span className='eleHeader'>Additional information:</span>
                    <textarea id='txtAdditionalinformation_2' name='txtAdditionalinformation_2' className='add-only'></textarea>
                </p>

                <h2>PREGNANCY & BIRTH HISTORY</h2>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Was your child adopted?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbadopted_No' name='rbadopted' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbadopted_Yes' name='rbadopted' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>If yes, at what age?</b>
                    <textarea id='txtwhatage' name='txtwhatage' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtchildadopted_1' name='txtchildadopted_1' className='add-only' value=' Domestic adoption' />  Domestic adoption </td>
                        <td className='w-187'><input type='checkbox' id='txtchildadopted_2' name='txtchildadopted_2' className='add-only' value=' International adoption ' />  International adoption  </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Information:</span>
                    <textarea id='txtAdditionalinformation_3' name='txtAdditionalinformation_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Were there any complications during pregnancy?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbduringpregnancy_No' name='rbpregnancy' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbduringpregnancy_Yes' name='rbpregnancy' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>please explain:</b>
                    <textarea id='txtpleaseexplain_1' name='txtpleaseexplain_1' className='add-only'></textarea>
                </p>

                <table>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtpregnancy_1' name='txtpregnancy_1' className='add-only' value='Full-term birth ' /> Full-term birth </td>
                        <td className='w-187'><input type='checkbox' id='txtpregnancy_2' name='txtpregnancy_2' className='add-only' value=' Premature birth' />  Premature birth </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtpregnancy_3' name='txtpregnancy_3' className='add-only' value=' Other:' /> Other: </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <textarea id='txtOthers_2' name='txtOthers_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Were there any complications during birth?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbbirth_No' name='rbbirth' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbbirth_Yes' name='rbbirth' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>please explain:</b>
                    <textarea id='txtpleaseexplain_2' name='txtpleaseexplain_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Were drugs or alcohol consumed during pregnancy?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbalcoholconsumed_No' name='rbalcoholconsumed' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbalcoholconsumed_Yes' name='rbalcoholconsumed' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>please explain:</b>
                    <textarea id='txtpleaseexplain_3' name='txtpleaseexplain_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Child's weight at birth?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' placeholder='lbs' id='txtweightatbirth_1' name='txtweightatbirth_1' className='add-only' /></td>
                        <td className='w-187'><input type='text' placeholder='oz' id='txtweightatbirth_2' name='txtweightatbirth_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>length</b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='text' id='txtweightatbirth_3' name='txtweightatbirth_3' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Child's health at birth?</span>
                    <textarea id='txtpleaseexplain_3' name='txtpleaseexplain_3' className='add-only'></textarea>

                    <span className='eleHeader'>Length of hospital stay?</span>
                    <textarea id='txthospitalstay' name='txthospitalstay' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Post-partum depression</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbdepression_No' name='rbdepression' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbdepression_Yes' name='rbdepression' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Information:</span>
                    <textarea id='txtAdditionalinformation_4' name='txtAdditionalinformation_4' className='add-only'></textarea>
                </p>

                <h2> DEVELOPMENTAL HISTORY</h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>As accurately as you can remember, how old was your child when she/he:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Rolled Over? </span> </td>
                        <td className='w-250'> <span className='eleHeader'>Crawled?</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Walked?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtRolledOver' name='txtRolledOver' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtCrawled' name='txtCrawled' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtWalked' name='txtWalked' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Talked (two words)?  </span> </td>
                        <td className='w-250'> <span className='eleHeader'>Toilet trained?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtTalked' name='txtTalked' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtCrawled' name='txtCrawled' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Do/did you have concerns about your child's development in any of these area (below): </span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtdevelopment_1' name='txtdevelopment_1' className='add-only' value=' Speech/language' />  Speech/language </td>
                        <td className='w-187'><input type='checkbox' id='txtdevelopment_2' name='txtdevelopment_2' className='add-only' value=' Motor skills' />  Motor skills </td>
                        <td className='w-187'><input type='checkbox' id='txtdevelopment_3' name='txtdevelopment_3' className='add-only' value=' Cognitive/intellectual' />  Cognitive/intellectual </td>
                        <td className='w-187'><input type='checkbox' id='txtdevelopment_4' name='txtdevelopment_4' className='add-only' value=' Sensory' /> Sensory </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtdevelopment_5' name='txtdevelopment_5' className='add-only' value=' Behavioral ' /> Behavioral  </td>
                        <td className='w-187'><input type='checkbox' id='txtdevelopment_6' name='txtdevelopment_6' className='add-only' value='  Emotional' />  Emotional </td>
                        <td className='w-187'><input type='checkbox' id='txtdevelopment_7' name='txtdevelopment_7' className='add-only' value='Social ' /> Social  </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtdevelopment_8' name='txtdevelopment_8' className='add-only' value=' Other:' />  Other: </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtOthers_3' name='txtOthers_3' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If so, please describe: </span>
                    <textarea id='txtpleasedescribe_1' name='txtpleasedescribe_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Were there any significant disturbances/changes during your child's childhood?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbsignificantdisturbances_No' name='rbsignificantdisturbances' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbsignificantdisturbances_Yes' name='rbsignificantdisturbances' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>If yes, please describe: </b>
                    <textarea id='txtpleasedescribe_2' name='txtpleasedescribe_2' className='add-only'></textarea>

                    <span className='eleHeader'>Additional Information:</span>
                    <textarea id='txtAdditionalinformation_5' name='txtAdditionalinformation_5' className='add-only'></textarea>
                </p>


                <h2>MEDICAL HEALTH HISTORY</h2>

                <p className='w-750'>
                    <span className='eleHeader'>How would you describe your child's overall health?  </span>
                    <textarea id='txtoverallhealth' name='txtoverallhealth' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Does your child have tubes in his/her ears?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbtubesinears_No' name='rbtubesinears' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbtubesinears_Yes' name='rbtubesinears' className='add-only' value='Yes:' /> Yes: </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <textarea id='txttubesinears' name='txttubesinears' className='add-only'></textarea>

                    <span className='eleHeader'>Additional Information:</span>
                    <textarea id='txtAdditionalinformation_6' name='txtAdditionalinformation_6' className='add-only'></textarea>

                    <span className='eleHeader'>Medical Conditions:</span>
                    <span className='small'> Include current significant medical problems, physical limitations, sleep limitations, sleep problems, unusual eating habits, poor hygiene, overall physical fitness, head injuries, early childhood infections, eating disorders, knee or back injuries, asthma, etc.)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbMedicalCond' name='cbMedicalCond' className='add-only' value='No medical conditions reported' /> No medical conditions reported<br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'> Medical Conditions</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedicalConditions_1' name='txtMedicalConditions_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Currently receiving treatment?</span></td>
                        <td className='w-200'><span className='eleHeader'>Provider </span></td>
                        <td className='w-200'><span className='eleHeader'>Does this condition cause stress or impairment at this time?</span></td>
                        <td className='w-200'><span className='eleHeader'>What have you found that helps?</span></td>
                    </tr>
                    <tr>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_1No' name='rbCurrentlyreceiving_1' className='add-only' value='No' />No </td>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_1Yes' name='rbCurrentlyreceiving_1' className='add-only' value='Yes' />Yes </td>
                        <td className='w-200'> <input type='text' id='txtProvider_1' name='txtProvider_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoesthiscondition_1' name='txtDoesthiscondition_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtfoundthathelps_1' name='txtfoundthathelps_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'> Medical Conditions</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedicalConditions_2' name='txtMedicalConditions_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Currently receiving treatment?</span></td>
                        <td className='w-200'><span className='eleHeader'>Provider </span></td>
                        <td className='w-200'><span className='eleHeader'>Does this condition cause stress or impairment at this time?</span></td>
                        <td className='w-200'><span className='eleHeader'>What have you found that helps?</span></td>
                    </tr>
                    <tr>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_2No' name='rbCurrentlyreceiving_2' className='add-only' value='No' />No </td>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_2Yes' name='rbCurrentlyreceiving_2' className='add-only' value='Yes' />Yes </td>
                        <td className='w-200'> <input type='text' id='txtProvider_2' name='txtProvider_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoesthiscondition_2' name='txtDoesthiscondition_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtfoundthathelps_2' name='txtfoundthathelps_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'> Medical Conditions</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedicalConditions_3' name='txtMedicalConditions_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Currently receiving treatment?</span></td>
                        <td className='w-200'><span className='eleHeader'>Provider </span></td>
                        <td className='w-200'><span className='eleHeader'>Does this condition cause stress or impairment at this time?</span></td>
                        <td className='w-200'><span className='eleHeader'>What have you found that helps?</span></td>
                    </tr>
                    <tr>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_3No' name='rbCurrentlyreceiving_3' className='add-only' value='No' />No </td>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_3Yes' name='rbCurrentlyreceiving_3' className='add-only' value='Yes' />Yes </td>
                        <td className='w-200'> <input type='text' id='txtProvider_3' name='txtProvider_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoesthiscondition_3' name='txtDoesthiscondition_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtfoundthathelps_3' name='txtfoundthathelps_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'> Medical Conditions</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedicalConditions_4' name='txtMedicalConditions_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Currently receiving treatment?</span></td>
                        <td className='w-200'><span className='eleHeader'>Provider </span></td>
                        <td className='w-200'><span className='eleHeader'>Does this condition cause stress or impairment at this time?</span></td>
                        <td className='w-200'><span className='eleHeader'>What have you found that helps?</span></td>
                    </tr>
                    <tr>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_4No' name='rbCurrentlyreceiving_4' className='add-only' value='No' />No </td>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_4Yes' name='rbCurrentlyreceiving_4' className='add-only' value='Yes' />Yes </td>
                        <td className='w-200'> <input type='text' id='txtProvider_4' name='txtProvider_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoesthiscondition_4' name='txtDoesthiscondition_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtfoundthathelps_4' name='txtfoundthathelps_4' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'> Medical Conditions</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedicalConditions_5' name='txtMedicalConditions_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Currently receiving treatment?</span></td>
                        <td className='w-200'><span className='eleHeader'>Provider </span></td>
                        <td className='w-200'><span className='eleHeader'>Does this condition cause stress or impairment at this time?</span></td>
                        <td className='w-200'><span className='eleHeader'>What have you found that helps?</span></td>
                    </tr>
                    <tr>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_5No' name='rbCurrentlyreceiving_5' className='add-only' value='No' />No </td>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_5Yes' name='rbCurrentlyreceiving_5' className='add-only' value='Yes' />Yes </td>
                        <td className='w-200'> <input type='text' id='txtProvider_5' name='txtProvider_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoesthiscondition_5' name='txtDoesthiscondition_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtfoundthathelps_5' name='txtfoundthathelps_5' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'> Medical Conditions</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedicalConditions_6' name='txtMedicalConditions_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Currently receiving treatment?</span></td>
                        <td className='w-200'><span className='eleHeader'>Provider </span></td>
                        <td className='w-200'><span className='eleHeader'>Does this condition cause stress or impairment at this time?</span></td>
                        <td className='w-200'><span className='eleHeader'>What have you found that helps?</span></td>
                    </tr>
                    <tr>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_6No' name='rbCurrentlyreceiving_6' className='add-only' value='No' />No </td>
                        <td className='w-75'> <input type='radio' id='rbCurrentlyreceiving_6Yes' name='rbCurrentlyreceiving_6' className='add-only' value='Yes' />Yes </td>
                        <td className='w-200'> <input type='text' id='txtProvider_6' name='txtProvider_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoesthiscondition_6' name='txtDoesthiscondition_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtfoundthathelps_6' name='txtfoundthathelps_6' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-190'><span className='eleHeader'>Medication</span></td>
                        <td className='w-90'><span className='eleHeader'>Dosage </span></td>
                        <td className='w-90'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-190'><span className='eleHeader'>Prescribed by</span></td>
                        <td className='w-190'><span className='eleHeader'>Reason for Medication</span></td>
                    </tr>
                    <tr>
                        <td className='w-190'> <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtPrescribedby_1' name='txtPrescribedby_1' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtReasonforMedication_1' name='txtReasonforMedication_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-190'> <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtPrescribedby_2' name='txtPrescribedby_2' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtReasonforMedication_2' name='txtReasonforMedication_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-190'> <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtPrescribedby_3' name='txtPrescribedby_3' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtReasonforMedication_3' name='txtReasonforMedication_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-190'> <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtPrescribedby_4' name='txtPrescribedby_4' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtReasonforMedication_4' name='txtReasonforMedication_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-190'> <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtPrescribedby_5' name='txtPrescribedby_5' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtReasonforMedication_5' name='txtReasonforMedication_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-190'> <input type='text' id='txtMedication_6' name='txtMedication_6' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtDosage_6' name='txtDosage_6' className='add-only' /> </td>
                        <td className='w-90'> <input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtPrescribedby_6' name='txtPrescribedby_6' className='add-only' /> </td>
                        <td className='w-190'> <input type='text' id='txtReasonforMedication_6' name='txtReasonforMedication_6' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is your child taking the medications as prescribed?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbmedicationsasprescribed_No' name='rbmedicationsasprescribed' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbmedicationsasprescribed_Yes' name='rbmedicationsasprescribed' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'> why? </span>
                    <textarea id='txtwhy_02' name='txtwhy_02' className='add-only'></textarea>
                    <span className='eleHeader'>Additional Information:</span>
                    <textarea id='txtAddinformation' name='txtAddinformation' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Has your child ever had a serious accident/illness or hospitalization? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='radio' id='rbhospitalization_No' name='rbhospitalization' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbhospitalization_Yes' name='rbhospitalization' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>please list below </span>
                    <textarea id='txtpleaselistbelow' name='txtpleaselistbelow' className='add-only'></textarea>

                    <b>Please list all past hospitalizations, surgeries, accidents, or illnesses in the chart below.</b>
                </p>

                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'> Reason for previous hospitalization, accident, illness</span></td>
                        <td className='w-250'><span className='eleHeader'>Date/location of hospitalization</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtprevioushospitalization_1' name='txtprevioushospitalization_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtlocationofhospitalization_1' name='txtlocationofhospitalization_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtprevioushospitalization_2' name='txtprevioushospitalization_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtlocationofhospitalization_2' name='txtlocationofhospitalization_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtprevioushospitalization_3' name='txtprevioushospitalization_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtlocationofhospitalization_3' name='txtlocationofhospitalization_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtprevioushospitalization_4' name='txtprevioushospitalization_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtlocationofhospitalization_4' name='txtlocationofhospitalization_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtprevioushospitalization_5' name='txtprevioushospitalization_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtlocationofhospitalization_5' name='txtlocationofhospitalization_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtprevioushospitalization_6' name='txtprevioushospitalization_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtlocationofhospitalization_6' name='txtlocationofhospitalization_6' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Has your child had the following screenings (please check all that apply)?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='txtscreenings' name='txtscreenings' className='add-only' value='Hearing screening date:' /> Hearing screening date: </td>
                        <td className='w-375'>Outcome:</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='date' id='txtscreeningdate' name='txtscreeningdate' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtOutcome_1' name='txtOutcome_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='txtscreenings' name='txtscreenings' className='add-only' value='Vision screening date:' /> Vision screening date: </td>
                        <td className='w-375'>Outcome:</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='date' id='txtscreeningdate' name='txtscreeningdate' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtOutcome_2' name='txtOutcome_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='txtscreenings' name='txtscreenings' className='add-only' value='Speech/language screening date' />Speech/language screening date </td>
                        <td className='w-375'>Outcome:</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='date' id='txtscreeningdate' name='txtscreeningdate' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtOutcome_3' name='txtOutcome_3' className='add-only' /></td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Dental problems:</span>
                    <textarea id='txtDentalproblems' name='txtDentalproblems' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Primary Care Doctor?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='radio' id='rbDoctor_Yes' name='rbDoctor' className='add-only' value='Male' /> Yes (name): </td>
                        <td className='w-375'>   <input type='radio' id='rbDoctor_No' name='rbDoctor' className='add-only' value='Female' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtDoctor' name='txtDoctor' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Facility:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFacility' name='txtFacility' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhone' name='txtPhone' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Date of last medical appointment</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtmedicalappointment' name='txtmedicalappointment' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Why?</span>
                    <textarea id='txtWhy' name='txtWhy' className='add-only'></textarea>

                    <span className='eleHeader'>Additional information:</span>
                    <textarea id='txtAdditionalinformation_7' name='txtAdditionalinformation_7' className='add-only'></textarea>
                </p>

                <h2> PSYCHIATRIC HISTORY</h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is your child currently being seen by a counselor/case manager?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbcounselor_No' name='rbcounselor' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbcounselor_Yes' name='rbcounselor' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> If yes, where?</span>
                    <textarea id='txtwhere' name='txtwhere' className='add-only'></textarea>

                    <span className='eleHeader'>Length if treatment?</span>
                    <textarea id='txtLengthiftreatment' name='txtLengthiftreatment' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is your child currently being seen by a psychiatrist?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbpsychiatrist_No' name='rbpsychiatrist' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbpsychiatrist_Yes' name='rbpsychiatrist' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'> If yes, name of current psychiatrist?</span>
                    <textarea id='txtcurrentpsychiatrist' name='txtcurrentpsychiatrist' className='add-only'></textarea>

                    <span className='eleHeader'>Length if treatment?</span>
                    <textarea id='txtLengthiftreatment_1' name='txtLengthiftreatment_1' className='add-only'></textarea>

                    <span className='eleHeader'>Diagnosis (in client's words, their explanations):</span>
                    <textarea id='txtDiagnosis_1' name='txtDiagnosis_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age of first diagnosis: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtfirstdiagnosis' name='txtfirstdiagnosis' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Why given diagnosis? What was going on? (i.e. symptoms, behaviors): </span>
                    <textarea id='txtgivendiagnosis' name='txtgivendiagnosis' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Has your child ever been hospitalized for mental health or drug and alcohol concerns in the past?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbdrugandalcohol_No' name='rbdrugandalcohol' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbdrugandalcohol_Yes' name='rbdrugandalcohol' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Date or Age:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDateorAge' name='txtDateorAge' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Where? </span>
                    <textarea id='txtWhere_2' name='txtWhere_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>How long in the hospital?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbhospital_1' name='cbhospital_1' className='add-only' value='24 hours' /> 24 hours </td>
                        <td className='w-250'><input type='checkbox' id='cbhospital_2' name='cbhospital_2' className='add-only' value='less than 1 week' />less than 1 week</td>
                        <td className='w-250'><input type='checkbox' id='cbhospital_3' name='cbhospital_3' className='add-only' value=' 1 - 2 weeks' />  1 - 2 weeks</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbhospital_4' name='cbhospital_4' className='add-only' value='2 - 4 weeks' />2 - 4 weeks</td>
                        <td className='w-250'><input type='checkbox' id='cbhospital_5' name='cbhospital_5' className='add-only' value=' month+' /> month+</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> What was going on? </span>
                    <textarea id='txtgoingon' name='txtgoingon' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Total hospitalizations:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbhospitalizations_1' name='cbhospitalizations_1' className='add-only' value='Less than 5' /> Less than 5 </td>
                        <td className='w-250'><input type='checkbox' id='cbhospitalizations_2' name='cbhospitalizations_2' className='add-only' value='5 - 10' />5 - 10</td>
                        <td className='w-250'><input type='checkbox' id='cbhospitalizations_3' name='cbhospitalizations_3' className='add-only' value='10 or more' /> 10 or more</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Average length of stay:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAveragelength_1' name='cbAveragelength_1' className='add-only' value='1 - 2 weeks' /> 1 - 2 weeks</td>
                        <td className='w-250'><input type='checkbox' id='cbAveragelength_2' name='cbAveragelength_2' className='add-only' value=' 2 - 4 weeks' /> 2 - 4 weeks</td>
                        <td className='w-250'><input type='checkbox' id='cbAveragelength_3' name='cbAveragelength_3' className='add-only' value=' month+' />  month+</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information:</span>
                    <textarea id='txtAdditionalinformation_8' name='txtAdditionalinformation_8' className='add-only'></textarea>
                </p>

                <h2>FAMILY MENTAL HEALTH HISTORY</h2>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Please identify if any members of your family have a history of any of the following mental health/drug abuse/legal concerns:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Mother:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMother_1' name='cbMother_1' className='add-only' value='Depression' /> Depression</td>
                        <td className='w-187'><input type='checkbox' id='cbMother_2' name='cbMother_2' className='add-only' value=' Anxiety' /> Anxiety</td>
                        <td className='w-187'><input type='checkbox' id='cbMother_3' name='cbMother_3' className='add-only' value=' Bipolar Disorder' /> Bipolar Disorder</td>
                        <td className='w-187'><input type='checkbox' id='cbMother_4' name='cbMother_4' className='add-only' value=' Schizophrenia' /> Schizophrenia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMother_5' name='cbMother_5' className='add-only' value='ADHD/ADD' />ADHD/ADD</td>
                        <td className='w-187'><input type='checkbox' id='cbMother_6' name='cbMother_6' className='add-only' value='Trauma History' />Trauma History</td>
                        <td className='w-187'><input type='checkbox' id='cbMother_7' name='cbMother_7' className='add-only' value='Abusive Behavior' />Abusive Behavior</td>
                        <td className='w-187'><input type='checkbox' id='cbMother_8' name='cbMother_8' className='add-only' value='Alcohol Abuse' /> Alcohol Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMother_9' name='cbMother_9' className='add-only' value='Drug Abuse' />Drug Abuse</td>
                        <td className='w-187'><input type='checkbox' id='cbMother_10' name='cbMother_10' className='add-only' value='Incarceration' />Incarceration</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMother_11' name='cbMother_11' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_4' name='txtOthers_4' className='add-only' /> </td>
                    </tr>


                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Father:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFather_1' name='cbFather_1' className='add-only' value='Depression' /> Depression</td>
                        <td className='w-187'><input type='checkbox' id='cbFather_2' name='cbFather_2' className='add-only' value=' Anxiety' /> Anxiety</td>
                        <td className='w-187'><input type='checkbox' id='cbFather_3' name='cbFather_3' className='add-only' value=' Bipolar Disorder' /> Bipolar Disorder</td>
                        <td className='w-187'><input type='checkbox' id='cbFather_4' name='cbFather_4' className='add-only' value=' Schizophrenia' /> Schizophrenia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFather_5' name='cFather_5' className='add-only' value='ADHD/ADD' />ADHD/ADD</td>
                        <td className='w-187'><input type='checkbox' id='cbFather_6' name='cbFather_6' className='add-only' value='Trauma History' />Trauma History</td>
                        <td className='w-187'><input type='checkbox' id='cbFather_7' name='cbFather_7' className='add-only' value='Abusive Behavior' />Abusive Behavior</td>
                        <td className='w-187'><input type='checkbox' id='cbFather_8' name='cbFather_8' className='add-only' value='Alcohol Abuse' /> Alcohol Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFather_9' name='cbFather_9' className='add-only' value='Drug Abuse' />Drug Abuse</td>
                        <td className='w-187'><input type='checkbox' id='cbFather_10' name='cbFather_10' className='add-only' value='Incarceration' />Incarceration</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFather_11' name='cbFather_11' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_5' name='txtOthers_5' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Sister:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSister_1' name='cbSister_1' className='add-only' value='Depression' /> Depression</td>
                        <td className='w-187'><input type='checkbox' id='cbSister_2' name='cbSister_2' className='add-only' value=' Anxiety' /> Anxiety</td>
                        <td className='w-187'><input type='checkbox' id='cbSister_3' name='cbSister_3' className='add-only' value=' Bipolar Disorder' /> Bipolar Disorder</td>
                        <td className='w-187'><input type='checkbox' id='cbSister_4' name='cbSister_4' className='add-only' value=' Schizophrenia' /> Schizophrenia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSister_5' name='cbSister_5' className='add-only' value='ADHD/ADD' />ADHD/ADD</td>
                        <td className='w-187'><input type='checkbox' id='cbSister_6' name='cbSister_6' className='add-only' value='Trauma History' />Trauma History</td>
                        <td className='w-187'><input type='checkbox' id='cbSister_7' name='cbSister_7' className='add-only' value='Abusive Behavior' />Abusive Behavior</td>
                        <td className='w-187'><input type='checkbox' id='cbSister_8' name='cbSister_8' className='add-only' value='Alcohol Abuse' /> Alcohol Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSister_9' name='cbSister_9' className='add-only' value='Drug Abuse' />Drug Abuse</td>
                        <td className='w-187'><input type='checkbox' id='cbSister_10' name='cbSister_10' className='add-only' value='Incarceration' />Incarceration</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSister_11' name='cbSister_11' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_6' name='txtOthers_6' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Brother:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBrother_1' name='cbBrother_1' className='add-only' value='Depression' /> Depression</td>
                        <td className='w-187'><input type='checkbox' id='cbBrother_2' name='cbBrother_2' className='add-only' value=' Anxiety' /> Anxiety</td>
                        <td className='w-187'><input type='checkbox' id='cbBrother_3' name='cbBrother_3' className='add-only' value=' Bipolar Disorder' /> Bipolar Disorder</td>
                        <td className='w-187'><input type='checkbox' id='cbBrother_4' name='cbBrother_4' className='add-only' value=' Schizophrenia' /> Schizophrenia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBrother_5' name='cbBrother_5' className='add-only' value='ADHD/ADD' />ADHD/ADD</td>
                        <td className='w-187'><input type='checkbox' id='cbBrother_6' name='cbBrother_6' className='add-only' value='Trauma History' />Trauma History</td>
                        <td className='w-187'><input type='checkbox' id='cbBrother_7' name='cbBrother_7' className='add-only' value='Abusive Behavior' />Abusive Behavior</td>
                        <td className='w-187'><input type='checkbox' id='cbBrother_8' name='cbBrother_8' className='add-only' value='Alcohol Abuse' /> Alcohol Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBrother_9' name='cbBrother_9' className='add-only' value='Drug Abuse' />Drug Abuse</td>
                        <td className='w-187'><input type='checkbox' id='cbBrother_10' name='cbBrother_10' className='add-only' value='Incarceration' />Incarceration</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBrother11' name='cbBrother_11' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_7' name='txtOthers_7' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Other:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_8' name='txtOthers_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_1' name='cbOther_1' className='add-only' value='Depression' /> Depression</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_2' name='cbOther_2' className='add-only' value=' Anxiety' /> Anxiety</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_3' name='cbOther_3' className='add-only' value=' Bipolar Disorder' /> Bipolar Disorder</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_4' name='cbOther_4' className='add-only' value=' Schizophrenia' /> Schizophrenia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_5' name='cbOther_5' className='add-only' value='ADHD/ADD' />ADHD/ADD</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_6' name='cbOther_6' className='add-only' value='Trauma History' />Trauma History</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_7' name='cbOther_7' className='add-only' value='Abusive Behavior' />Abusive Behavior</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_8' name='cbOther_8' className='add-only' value='Alcohol Abuse' /> Alcohol Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_9' name='cbOther_9' className='add-only' value='Drug Abuse' />Drug Abuse</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_10' name='cbOther_10' className='add-only' value='Incarceration' />Incarceration</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_11' name='cbOther_11' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_9' name='txtOthers_9' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Other:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_10' name='txtOthers_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_12' name='cbOther_12' className='add-only' value='Depression' /> Depression</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_13' name='cbOther_13' className='add-only' value=' Anxiety' /> Anxiety</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_14' name='cbOther_14' className='add-only' value=' Bipolar Disorder' /> Bipolar Disorder</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_15' name='cbOther_15' className='add-only' value=' Schizophrenia' /> Schizophrenia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_16' name='cbOther_16' className='add-only' value='ADHD/ADD' />ADHD/ADD</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_17' name='cbOther_17' className='add-only' value='Trauma History' />Trauma History</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_18' name='cbOther_18' className='add-only' value='Abusive Behavior' />Abusive Behavior</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_19' name='cbOther_19' className='add-only' value='Alcohol Abuse' /> Alcohol Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_20' name='cbOther_20' className='add-only' value='Drug Abuse' />Drug Abuse</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_21' name='cbOther_21' className='add-only' value='Incarceration' />Incarceration</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_22' name='cbOther_22' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_11' name='txtOthers_11' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information:</span>
                    <textarea id='txtAdditionalinformation_9' name='txtAdditionalinformation_9' className='add-only'></textarea>
                </p>

                <h2>SAFETY CONCERNS</h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is your child presently suicidal?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbpresentlysuicidal_No' name='rbpresentlysuicidal' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbpresentlysuicidal_Yes' name='rbpresentlysuicidal' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>please explain: </span>
                    <textarea id='txtpleaseex' name='txtpleaseex' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Has your child ever attempted to commit suicide?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbcommitsuicide_No' name='rbcommitsuicide' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbcommitsuicide_Yes' name='rbcommitsuicide' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>if yes, when and how? </span>
                    <textarea id='txtyeswhenandhow' name='txtyeswhenandhow' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is there a history of suicide in your child's immediate and/or extended family?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbimmediate_No' name='rbimmediate' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbimmediate_Yes' name='rbimmediate' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, please explain:</span>
                    <textarea id='txtIfyes' name='txtIfyes' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Has your child ever inflicted burns or wound on his/herself?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbinflictedburns_No' name='rbinflictedburns' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbinflictedburns_Yes' name='rbinflictedburns' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, please explain:</span>
                    <textarea id='txtIfyespleaseexplain' name='txtIfyespleaseexplain' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is your child presently homicidal?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbchildpresentlyhomicidal_No' name='rbchildpresentlyhomicidal' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbchildpresentlyhomicidal_Yes' name='rbchildpresentlyhomicidal' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, please explain:</span>
                    <textarea id='txtIfyespleaseexplain_1' name='txtIfyespleaseexplain_1' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information (please list additional information as needed to address past and current safety issues):</span>
                    <textarea id='txtAdditionalinformation_10' name='txtAdditionalinformation_10' className='add-only'></textarea>
                </p>

                <h2>CURRENT FUNCTIONING</h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Do you have concerns about your child in the following areas? </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(check all that apply)</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbfollowingareas_1' name='cbfollowingareas_1' className='add-only' value='Eating' />Eating</td>
                        <td className='w-250'><input type='checkbox' id='cbfollowingareas_2' name='cbfollowingareas_2' className='add-only' value='Hygiene/grooming' />Hygiene/grooming</td>
                        <td className='w-250'><input type='checkbox' id='cbfollowingareas_3' name='cbfollowingareas_3' className='add-only' value='Sleeping' />Sleeping</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbfollowingareas_4' name='cbfollowingareas_4' className='add-only' value='Activities/play' /> Activities/play</td>
                        <td className='w-250'><input type='checkbox' id='cbfollowingareas_5' name='cbfollowingareas_5' className='add-only' value='Social Relationships' /> Social Relationships</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbfollowingareas_6' name='cbfollowingareas_6' className='add-only' value='Other:' /> Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOthers_12' name='txtOthers_12' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, please describe:</span>
                    <textarea id='txtIfyespleasedescribe' name='txtIfyespleasedescribe' className='add-only'></textarea>
                </p>

                <h2>THE SOCIAL ATTRIBUTES CHECKLIST</h2>


                <p className='w-750'>
                    <span className='small'>Source: McCllellan, D. & Katz, L.</span>
                    <b>Individual Attributes </b> <br />
                    <b>The child:</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is USUALLY in a positive mood</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbpositivemood_No' name='rbpositivemood' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbpositivemood_Yes' name='rbpositivemood' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is not EXCESSIVELY dependent on the teacher, assistant, or other adults</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbEXCESSIVELYdependent_No' name='rbEXCESSIVELYdependent' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbEXCESSIVELYdependent_Yes' name='rbEXCESSIVELYdependent' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>USUALLY comes to the program or setting willingly</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbwillingly_No' name='rbwillingly' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbwillingly_Yes' name='rbwillingly' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>USUALLY copes with rebuffs and reverses adequately</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbreversesadequately_No' name='rbreversesadequately' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbreversesadequately_Yes' name='rbreversesadequately' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Shows the capacity to empathize</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbempathize_No' name='rbempathize' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbempathize_Yes' name='rbempathize' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Has positive relationships with one or two peers; shows capacity to really care about them, miss them if absent, etc.</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbpositiverelationships_No' name='rbpositiverelationships' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbpositiverelationships_Yes' name='rbpositiverelationships' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Displays the capacity for humor</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbhumor_No' name='rbhumor' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbhumor_Yes' name='rbhumor' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Does not seem to be acutely or chronically lonely</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbchronicallylonely_No' name='rbchronicallylonely' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbchronicallylonely_Yes' name='rbchronicallylonely' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <h2> Social Skill Attributes</h2>

                <p className='w-750'>
                    <b>The child USUALLY:</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Approaches others positively</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbApproachesothers_No' name='rbApproachesothers' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbApproachesothers_Yes' name='rbApproachesothers' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Expresses wishes and preferences clearly; gives reasons for actions and positions</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbactionsandpositions_No' name='rbactionsandpositions' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbactionsandpositions_Yes' name='rbactionsandpositions' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Asserts own rights and needs appropriately</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbneedsappropriatey_No' name='rbneedsappropriatey' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbneedsappropriatey_Yes' name='rbneedsappropriatey' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is not easily intimidated by bullies</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbbullies_No' name='rbbullies' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbbullies_Yes' name='rbbullies' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Expresses frustrations and anger effectively and without harming others or property</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbharmingothers_No' name='rbharmingothers' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbharmingothers_Yes' name='rbharmingothers' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Gains access to ongoing discussion groups at play and work</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbGainsaccess_No' name='rbGainsaccess' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbGainsaccess_Yes' name='rbGainsaccess' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Enters ongoing discussion on the ; makes relevant contributions to ongoing activities</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbsubject_No' name='rbsubject' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbsubject_Yes' name='rbsubject' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Takes turns fairly easily</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbfairlyeasily_No' name='rbfairlyeasily' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbfairlyeasily_Yes' name='rbfairlyeasily' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Shows interest in others; exchanges information with and request information from others appropriately</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbrequestinformation_No' name='rbrequestinformation' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbrequestinformation_Yes' name='rbrequestinformation' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Does not draw inappropriate attention to self</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbattentiontoself_No' name='rbattentiontoself' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbattentiontoself_Yes' name='rbattentiontoself' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Accepts and enjoys peers and adults of ethnic groups other his or her own</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbethnicgroups_No' name='rbethnicgroups' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbethnicgroups_Yes' name='rbethnicgroups' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Gains access to ongoing groups at play and work</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbgroupsatplay_No' name='rbgroupsatplays' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbgroupsatplay_Yes' name='rbgroupsatplay' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Interacts non-verbally with other children with smiles, waves, nods, etc.</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbsmiles_No' name='rbsmiles' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbsmiles_Yes' name='rbsmiles' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <h2>Peer Relationship Attributes</h2>

                <p className='w-750'>
                    <b> The child is:</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>USUALLY accepted versus neglected or rejected by other children</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbneglectedorrejected_No' name='rbneglectedorrejected' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbneglectedorrejected_Yes' name='rbneglectedorrejected' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>SOMETIMES invited by other children to join with smiles, waves, nods, etc</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbwaves_No' name='rbwaves' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbwaves_Yes' name='rbwaves' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_11' name='txtAdditionalinformation_11' className='add-only'></textarea>
                </p>

                <h2>PARENT/CHILD RELATIONSHIP</h2>

                <p className='w-750'>
                    <span className='eleHeader'> Describe parenting your child (e.g. challenging, easy): </span>
                    <textarea id='txtparenting' name='txtparenting' className='add-only'></textarea>

                    <span className='eleHeader'>What do you find most challenging in parenting your child?</span>
                    <textarea id='txtmostchallenging' name='txtmostchallenging' className='add-only'></textarea>

                    <span className='eleHeader'> What kind of discipline works best for your child?</span>
                    <textarea id='txtdiscipline' name='txtdiscipline' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAddinformation' name='txtAddinformation' className='add-only'></textarea>
                </p>

                <h2> EDUCATION</h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Is your child currently enrolled in school?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbenrolledinschool_No' name='rbenrolledinschool' className='add-only' value='No' />No</td>
                        <td className='w-187'><input type='radio' id='rbenrolledinschool_Yes' name='rbenrolledinschool' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name of School:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtNameofSchool' name='txtNameofSchool' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> What grade is your child currently in (if summer, grade your child is going into)? </span>
                    <textarea id='txtcurrentlyin' name='txtcurrentlyin' className='add-only'></textarea>

                    <span className='eleHeader'>How would you describe your child's grades in school?  </span>
                    <textarea id='txtgradesinschool' name='txtgradesinschool' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_12' name='txtAdditionalinformation_12' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>How would you describe your child's attendance (currently)? Check all that apply</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbchildattendance_1' name='cbchildattendance_1' className='add-only' value='Attending regularly' /> Attending regularly</td>
                        <td className='w-187'><input type='checkbox' id='cbchildattendance_2' name='cbchildattendance_2' className='add-only' value='Home-schooled' /> Home-schooled</td>
                        <td className='w-187'><input type='checkbox' id='cbchildattendance_3' name='cbchildattendance_3' className='add-only' value='Some-truancy' /> Some-truancy </td>
                        <td className='w-187'><input type='checkbox' id='cbchildattendance_4' name='cbchildattendance_4' className='add-only' value='Alternative school' /> Alternative school </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbchildattendance_5' name='cbchildattendance_5' className='add-only' value='Suspended' />Suspended</td>
                        <td className='w-187'><input type='checkbox' id='cbchildattendance_6' name='cbchildattendance_6' className='add-only' value='Expelled' /> Expelled</td>
                        <td className='w-187'><input type='checkbox' id='cbchildattendance_7' name='cbchildattendance_7' className='add-only' value='GED program' /> GED program</td>
                        <td className='w-187'><input type='checkbox' id='cbchildattendance_8' name='cbchildattendance_8' className='add-only' value='Dropped-out' />Dropped-out </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Please describe/explain any checked answers above:</span>
                    <textarea id='txtPleasedescribe' name='txtPleasedescribe' className='add-only'></textarea>

                    <span className='eleHeader'>How would you describe your child's attitude towards school/education? </span>
                    <textarea id='txttowardsschool' name='txttowardsschool' className='add-only'></textarea>

                    <span className='eleHeader'>If yes, please describe:</span>
                    <textarea id='txtIfyespleasedes' name='txtIfyespleasedes' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_13' name='txtAdditionalinformation_13' className='add-only'></textarea>
                </p>

                <h2>EDUCATION CLASSIFICATION</h2>
                <p className='w-750'>
                    <b> Please check if your child has any of the following?</b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_1' name='cbeducationclassification_1' className='add-only' value='None Reported (No special classifications)' />None Reported (No special classifications)</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_2' name='cbeducationclassification_2' className='add-only' value='Written Education Plan (WEP):' />Written Education Plan (WEP):</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_3' name='cbeducationclassification_3' className='add-only' value='Superior Cognitive Ability' />Superior Cognitive Ability</td>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_4' name='cbeducationclassification_4' className='add-only' value='Creative Thinking Ability' />Creative Thinking Ability</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_5' name='cbeducationclassification_5' className='add-only' value='Specific Academic Ability:' />Specific Academic Ability:</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtSpecificAcademic' name='txtSpecificAcademic' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_6' name='cbeducationclassification_6' className='add-only' value='Special Education Accommodations or a 504?' />Special Education Accommodations or a 504?</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_1' name='txtPleasedescribe_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_7' name='cbeducationclassification_7' className='add-only' value='An Individualized Education Plan (IEP)?' />An Individualized Education Plan (IEP)?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_2' name='txtPleasedescribe_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_8' name='cbeducationclassification_8' className='add-only' value=' Diagnosed Learning Disability?' /> Diagnosed Learning Disability?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_3' name='txtPleasedescribe_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_9' name='cbeducationclassification_9' className='add-only' value='Receiving special services at school?' />Receiving special services at school?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_4' name='txtPleasedescribe_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_10' name='cbeducationclassification_10' className='add-only' value='Severely Emotionally Disturbed (SED)?' />Severely Emotionally Disturbed (SED)?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_5' name='txtPleasedescribe_5' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_11' name='cbeducationclassification_11' className='add-only' value='Specific Learning Disability?' />Specific Learning Disability?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_6' name='txtPleasedescribe_6' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_12' name='cbeducationclassification_12' className='add-only' value='Mental Retardation or Intellectual Disability?' />Mental Retardation or Intellectual Disability?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_7' name='txtPleasedescribe_7' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_13' name='cbeducationclassification_13' className='add-only' value='Autism Spectrum?' />Autism Spectrum?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_8' name='txtPleasedescribe_8' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_14' name='cbeducationclassification_14' className='add-only' value='Deafness (hearing impairment)?' />Deafness (hearing impairment)?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_9' name='txtPleasedescribe_9' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_15' name='cbeducationclassification_15' className='add-only' value='Deaf-Blindness?' />Deaf-Blindness?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_10' name='txtPleasedescribe_10' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_16' name='cbeducationclassification_16' className='add-only' value=' Speech or Language Impairment?' /> Speech or Language Impairment?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_11' name='txtPleasedescribe_11' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_17' name='cbeducationclassification_17' className='add-only' value='Orthopedic Impairment?' /> Orthopedic Impairment?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_12' name='txtPleasedescribe_12' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbeducationclassification_18' name='cbeducationclassification_18' className='add-only' value='Other?' />Other?</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtDateBirth' name='txtDateBirth' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    Please describe:
                    <textarea id='txtPleasedescribe_13' name='txtPleasedescribe_13' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_14' name='txtAdditionalinformation_14' className='add-only'></textarea>
                </p>

                <h2>SCHOOL FUNCTIONING</h2>



                <p className='w-750'><span className='eleHeader'>Disciplinary or behavioral issued at school?  Please describe:</span>
                    <textarea id='txtDisciplinaryor' name='txtDisciplinaryor' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbDisciplinary' name='cbDisciplinary' className='add-only' value='None Reported' />None Reported</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Previous Grade Retentions: Please describe:</span>
                    <textarea id='txtPreviousGrade' name='txtPreviousGrade' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRetentions' name='cbRetentions' className='add-only' value='None Reported' />None Reported</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Suspensions/Expulsions: Please describe:</span>
                    <textarea id='txtExpulsions' name='txtExpulsions' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSuspensions' name='cbSuspensions' className='add-only' value='None Reported' />None Reported</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Other Academic/School Concerns: Please describe:</span>
                    <textarea id='txtSchoolConcerns' name='txtSchoolConcerns' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbOtherAcademic' name='cbOtherAcademic' className='add-only' value='None Reported' />None Reported</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Barriers to Learning: 0 Inability to Read and Write</span>
                    <textarea id='txtBarriers' name='txtBarriers' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbBarrierstoLearning' name='cbBarrierstoLearning' className='add-only' value='None Reported' />None Reported</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Other:</span>
                    <textarea id='txtOthers_13' name='txtOthers_13' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbOther_23' name='cbOther_23' className='add-only' value='None Reported' />None Reported</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Special Communication Needs:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpecialCommunication_1' name='cbSpecialCommunication_1' className='add-only' value='TDD/TYY Device' /> TDD/TYY Device </td>
                        <td className='w-250'><input type='checkbox' id='cbSpecialCommunication_2' name='cbSpecialCommunication_2' className='add-only' value='Sign Language Interpreter' /> Sign Language Interpreter</td>
                        <td className='w-250'><input type='checkbox' id='cbSpecialCommunication_3' name='cbSpecialCommunication_3' className='add-only' value='Assistive Listening Device(s)' /> Assistive Listening Device(s) </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSpecialCommunication_4' name='cbSpecialCommunication_4' className='add-only' value='Language Interpreter Services Needed/Other Spoken Language:' /> Language Interpreter Services Needed/Other Spoken Language: </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtLanguageInterpreter' name='txtLanguageInterpreter' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbOther_24' name='cbOther_24' className='add-only' value='None Reported' />None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_15' name='txtAdditionalinformation_15' className='add-only'></textarea>
                </p>

                <h2>EMPLOYMENT</h2>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbEMPLOYMENT' name='cbEMPLOYMENT' className='add-only' value='No History of Employment Reported' />No History of Employment Reported</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Is your child currently employed?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbcurrentlyemployed_No' name='rbcurrentlyemployed' className='add-only' value='No' /> No</td>
                        <td className='w-250'><input type='radio' id='rbcurrentlyemployed_Yes' name='rbcurrentlyemployed' className='add-only' value='Yes:' /> Yes:</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbchildcurrently_1' name='cbchildcurrently_1' className='add-only' value='Part-time or' />Part-time or</td>
                        <td className='w-250'><input type='checkbox' id='cbchildcurrently_2' name='cbchildcurrently_2' className='add-only' value='Full-time' />Full-time</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbchildcurrently_1' name='cbchildcurrently_1' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtOthers_14' name='txtOthers_14' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If employed, where are they working?</span>
                    <textarea id='txtIfemployed' name='txtIfemployed' className='add-only'></textarea>

                    <span className='eleHeader'>How long?</span>
                    <textarea id='txtHowlong' name='txtHowlong' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Does your child enjoy their current job?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbcurrentjob_No' name='rbcurrentjob' className='add-only' value='No' /> No</td>
                        <td className='w-250'><input type='radio' id='rbcurrentjob_Yes' name='rbcurrentjob' className='add-only' value='Yes' /> Yes</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Any concerns with employment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbemployment_No' name='rbemployment' className='add-only' value='No' /> No</td>
                        <td className='w-250'><input type='radio' id='rbemployment_Yes' name='rbemployment' className='add-only' value='Yes:' /> Yes:</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtwithemployment' name='txtwithemployment' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_16' name='txtAdditionalinformation_16' className='add-only'></textarea>
                </p>

                <h2>ETHNICITY/CULTURAL/SPIRITUAL/RELIGIOUS BELIEFS</h2>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Select activities in which your child participates:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbchildparticipates_1' name='cbchildparticipates_1' className='add-only' value='Art' />Art</td>
                        <td className='w-250'><input type='checkbox' id='cbchildparticipates_2' name='cbchildparticipates_2' className='add-only' value='Music' />Music</td>
                        <td className='w-250'><input type='checkbox' id='cbchildparticipates_3' name='cbchildparticipates_3' className='add-only' value='Exercise/Sports' />Exercise/Sports</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbchildparticipates_4' name='cbchildparticipates_4' className='add-only' value='Religious activities' />Religious activities</td>
                        <td className='w-250'><input type='checkbox' id='cbchildparticipates_5' name='cbchildparticipates_5' className='add-only' value='Reading' />Reading</td>
                        <td className='w-250'><input type='checkbox' id='cbchildparticipates_6' name='cbchildparticipates_6' className='add-only' value='None' />None</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbchildparticipates_7' name='cbchildparticipates_7' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtOthers_15' name='txtOthers_15' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Comment on frequency and importance to client:</span>
                    <textarea id='txtimportancetoclient' name='txtimportancetoclient' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Does your child have friends?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbhavefriends_No' name='rbhavefriends' className='add-only' value='No' /> No</td>
                        <td className='w-250'><input type='radio' id='rbhavefriends_Yes' name='rbhavefriends' className='add-only' value='Yes' /> Yes</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>How many?</span>
                    <textarea id='txtHow' name='txtHow' className='add-only'></textarea>

                    <span className='eleHeader'> How much time does your child spend with friends?</span>
                    <textarea id='txtwithfriends' name='txtwithfriends' className='add-only'></textarea>

                    <span className='eleHeader'> Is your child religious or spiritual?</span>
                    <textarea id='txtchildreligious' name='txtchildreligious' className='add-only'></textarea>

                    <span className='eleHeader'>Does your ethnic background/religion/spirituality/culture require special considerations?</span>
                    <textarea id='txtethnicbackground' name='txtethnicbackground' className='add-only'></textarea>


                    <span className='eleHeader'>Do you celebrate any special traditions of holidays?</span>
                    <textarea id='txtspecialtraditions' name='txtspecialtraditions' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_17' name='txtAdditionalinformation_17' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>GENDER IDENTITY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbGENDERIDENTITY' name='cbGENDERIDENTITY' className='add-only' value='No Significant Gender Identification Reported' />No Significant Gender Identification Reported</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Gender Identity (if relevant):</span>
                    <textarea id='txtIdentity' name='txtIdentity' className='add-only'></textarea>

                    <span className='eleHeader'>Preferred Pronoun:</span>
                    <textarea placeholder='{Choose One}' id='txtIdentity' name='txtIdentity' className='add-only'></textarea>

                    <span className='eleHeader'>Sexual/Romantic Orientation:</span>
                    <textarea id='txtRomanticOrientation' name='txtRomanticOrientation' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_18' name='txtAdditionalinformation_18' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> FOSTER CARE INVOLVEMENT</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbFOSTERCARE' name='cbFOSTERCARE' className='add-only' value='No History of Foster Care Reported' />No History of Foster Care Reported</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has your child ever been in foster care?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbfostercare_No' name='rbfostercare' className='add-only' value='No' /> No</td>
                        <td className='w-250'><input type='radio' id='rbfostercare_Yes' name='rbfostercare' className='add-only' value='Yes:' /> Yes:</td>
                    </tr>
                </table>


                <p className='w-750'>
                    From age:
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='text' id='txtFromage' name='txtFromage' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    to age:
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='text' id='txttoage' name='txttoage' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Reason:</span>
                    <textarea id='txtReasons' name='txtReasons' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Type of placement:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTypeofplacement_1' name='cbTypeofplacement_1' className='add-only' value='Familial placement' />Familial placement</td>
                        <td className='w-250'><input type='checkbox' id='cbTypeofplacement_2' name='cbTypeofplacement_2' className='add-only' value='Non-familial placement' />Non-familial placement</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCurrentstatus_1' name='cbCurrentstatus_1' className='add-only' value='In-care' />In-care</td>
                        <td className='w-250'><input type='checkbox' id='cbCurrentstatus_2' name='cbCurrentstatus_2' className='add-only' value='Out of care' />Out of care</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>If Out of Care, reason for leaving:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbreasonforleaving_1' name='cbreasonforleaving_1' className='add-only' value=' Adopted' /> Adopted</td>
                        <td className='w-250'><input type='checkbox' id='cbreasonforleaving_2' name='cbreasonforleaving_2' className='add-only' value='Returned to home' />Returned to home</td>
                        <td className='w-250'><input type='checkbox' id='cbreasonforleaving_3' name='cbreasonforleaving_3' className='add-only' value='Emancipated' />Emancipated</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbreasonforleaving_4' name='cbreasonforleaving_4' className='add-only' value='Ran away from care' />Ran away from care</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbreasonforleaving_5' name='cbreasonforleaving_5' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtOthers_16' name='txtOthers_16' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_19' name='txtAdditionalinformation_19' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>SUBSTANCE USE HISTORY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSUBSTANCEUSEHISTORY' name='cbSUBSTANCEUSEHISTORY' className='add-only' value='No History of Substance Use Reported' />No History of Substance Use Reported</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Severity Levels = Presence of the # of DSM 5 criteria symptoms Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>TOBACCO:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTOBACCO_1' name='cbTOBACCO_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbTOBACCO_2' name='cbTOBACCO_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_1' name='txtAgeat_1' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_1' name='txtLastuse_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_1' name='txtamount_1' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_1' name='txtFreq_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_1' name='txtRoute_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_1' name='cbTOBACCOS_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_2' name='cbTOBACCOS_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_3' name='cbTOBACCOS_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_4' name='cbTOBACCOS_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_5' name='cbTOBACCOS_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_6' name='cbTOBACCOS_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_7' name='cbTOBACCOS_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_8' name='cbTOBACCOS_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_9' name='cbTOBACCOS_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_10' name='cbTOBACCOS_10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_11' name='cbTOBACCOS_11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTOBACCOS_12' name='cbTOBACCOS_12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_20' name='txtAdditionalinformation_20' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ALCOHOL (beer, wine, liquor, etc.):</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbALCOHOL_1' name='cbALCOHOL_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbALCOHOL_2' name='cbALCOHOL_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_2' name='txtAgeat_2' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_2' name='txtLastuse_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_2' name='txtamount_2' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_2' name='txtFreq_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_2' name='txtRoute_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_1' name='cbALCOHOLS_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_2' name='cbALCOHOLS_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_3' name='cbALCOHOLS_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_4' name='cbALCOHOLS_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_5' name='cbALCOHOLS_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_6' name='cbALCOHOLS_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_7' name='cbALCOHOLS_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_8' name='cbALCOHOLS_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_9' name='cbALCOHOLS_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_10' name='cbALCOHOLS_10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_11' name='cbALCOHOLS_11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbALCOHOLS_12' name='cbALCOHOLS_12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_21' name='txtAdditionalinformation_21' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>CANNABIS (marijuana, marijuana related products): </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCANNABIS_1' name='cbALCOHOL_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbCANNABISL_2' name='cbALCOHOL_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtCANNABISAgeat' name='txtCANNABISAgeat' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtCANNABISLastuse' name='txtCANNABISLastuse' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtCANNABISLamount' name='txtCANNABISLamount' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtCANNABISLFreq' name='txtCANNABISLFreq' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtCANNABISLRoute' name='txtCANNABISLRoute' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_1' name='cbCANNABIS_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_2' name='cbCANNABIS_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_3' name='cbCANNABIS_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_4' name='cbCANNABIS_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_5' name='cbCANNABIS_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_6' name='cbCANNABIS_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_7' name='cbCANNABIS_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_8' name='cbCANNABIS_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_9' name='cbCANNABIS_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_10' name='cbCANNABIS_10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_11' name='cbCANNABIS_11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCANNABIS_12' name='cbCANNABIS_12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformat' name='txtAdditionalinformat' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>HALLUCINOGENS (LSD, ecstasy, Ketamine, mushrooms, etc.): </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHALLU_1' name='cbHALLU_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbHALLU_2' name='cbHALLU_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_3' name='txtAgeat_3' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_3' name='txtLastuse_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_3' name='txtamount_3' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_3' name='txtFreq_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_3' name='txtRoute_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_1' name='cbHALLUCINOGENS_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_2' name='cbHALLUCINOGENS_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_3' name='cbHALLUCINOGENS_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_4' name='cbHALLUCINOGENS_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_5' name='cbHALLUCINOGENS_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_6' name='cbHALLUCINOGENS_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_7' name='cbHALLUCINOGENS_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_8' name='cbHALLUCINOGENS_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_9' name='cbHALLUCINOGENS_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_10' name='cbHALLUCINOGENS_10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_11' name='cbHALLUCINOGENS_11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHALLUCINOGENS_12' name='cbHALLUCINOGENS_12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_22' name='txtAdditionalinformation_22' className='add-only'></textarea>
                </p>



                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>PHENCYCLIDINE (PCP):  </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPHENCYCLIDINE_1' name='cbPHENCYCLIDINE_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbPHENCYCLIDINE_2' name='cbPHENCYCLIDINE_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_4' name='txtAgeat_4' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_4' name='txtLastuse_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_4' name='txtamount_4' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_4' name='txtFreq_4' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_4' name='txtRoute_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_1' name='cbPHENCYCLIDINES_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_2' name='cbPHENCYCLIDINES_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_3' name='cbPHENCYCLIDINES_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_4' name='cbPHENCYCLIDINES_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_5' name='cbPHENCYCLIDINES_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_6' name='cbPHENCYCLIDINES_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_7' name='cbPHENCYCLIDINES_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_8' name='cbPHENCYCLIDINES_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_9' name='cbPHENCYCLIDINES_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_10' name='cbPHENCYCLIDINES_10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_11' name='cbPHENCYCLIDINES_11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPHENCYCLIDINES_12' name='cbPHENCYCLIDINES_12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_23' name='txtAdditionalinformation_23' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>INHALANTS (glues, sprays, cans):  </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbINHALANT_1' name='cbINHALANT_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbINHALANT_2' name='cbINHALANT_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_5' name='txtAgeat_5' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_5' name='txtLastuse_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_5' name='txtamount_5' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_5' name='txtFreq_5' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_5' name='txtRoute_5' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_1' name='cbINHALANTS_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_2' name='cbINHALANTS_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_3' name='cbINHALANTS_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_4' name='cbINHALANTS_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_5' name='cbINHALANTS_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_6' name='cbINHALANTS_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_7' name='cbINHALANTS_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_8' name='cbINHALANTS_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_9' name='cbINHALANTS_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_10' name='cbINHALANTS_10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_11' name='cbINHALANTS_11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbINHALANTS_12' name='cbINHALANTS_12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_24' name='txtAdditionalinformation_24' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>OPIOIDS (Heroin, Hydrocodone, Oxycodone, Morphine, Hydromorphone, Codeine, Meperidine, Fentanyl): </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOPIOID_1' name='cbOPIOID_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbOPIOID_2' name='cbOPIOID_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_6' name='txtAgeat_6' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_6' name='txtLastuse_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_6' name='txtamount_6' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_6' name='txtFreq_6' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_6' name='txtRoute_6' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_1' name='cbOPIOIDS_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_2' name='cbOPIOIDS_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_3' name='cbOPIOIDS_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_4' name='cbINHALANTS_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_5' name='cbOPIOIDS_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_6' name='cbOPIOIDS_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_7' name='cbOPIOIDS_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_8' name='cbOPIOIDS_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS_9' name='cbOPIOIDS_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS__10' name='cbOPIOIDS__10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS__11' name='cbOPIOIDS__11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOPIOIDS__12' name='cbOPIOIDS__12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_25' name='txtAdditionalinformation_25' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>SEDATIVE, HYPNOTIC, OR ANXIOLYTIC (Benzodiazepines: Xanax, Ativan, Valium, Klonopin; Barbiturates; Z drugs: Ambien, Lunesta, etc.):  </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSEDATIVE_1' name='cbSEDATIVE_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbSEDATIVE_2' name='cbSEDATIVE_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_7' name='txtAgeat_7' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_7' name='txtLastuse_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_7' name='txtamount_7' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_7' name='txtFreq_7' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_7' name='txtRoute_7' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_1' name='cbHYPNOTIC_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_2' name='cbHYPNOTIC_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_3' name='cbHYPNOTIC_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_4' name='cbHYPNOTIC_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_5' name='cbHYPNOTIC_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_6' name='cbHYPNOTIC_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_7' name='cbHYPNOTIC_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_8' name='cbHYPNOTIC_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC_9' name='cbHYPNOTIC_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC__10' name='cbHYPNOTIC__10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC__11' name='cbHYPNOTIC__11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHYPNOTIC__12' name='cbHYPNOTIC__12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_26' name='txtAdditionalinformation_26' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>STIMULANTS (Caffeine, Cocaine, Methamphetamine, Ritalin, Adderall, etc.): </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSTIMULANT_1' name='cbSTIMULANT_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbSTIMULANT_2' name='cbSTIMULANT_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_8' name='txtAgeat_8' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_8' name='txtLastuse_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_8' name='txtamount_8' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_8' name='txtFreq_8' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_8' name='txtRoute_8' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_1' name='cbSTIMULANTS_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_2' name='cbSTIMULANTS_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_3' name='cbSTIMULANTS_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_4' name='cbSTIMULANTS_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_5' name='cbSTIMULANTS_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_6' name='cbSTIMULANTS_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_7' name='cbSTIMULANTS_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_8' name='cbSTIMULANTS_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS_9' name='cbSTIMULANTS_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS__10' name='cbSTIMULANTS__10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS__11' name='cbSTIMULANTS__11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSTIMULANTS__12' name='cbSTIMULANTS__12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_27' name='txtAdditionalinformation_27' className='add-only'></textarea>
                </p>



                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>OTHER (unknown):  </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtOTHER_2' name='txtOTHER_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbunknown_1' name='cbunknown_1' className='add-only' value='Never Used' />Never Used</td>
                        <td className='w-250'><input type='checkbox' id='cbunknown_2' name='cbunknown_2' className='add-only' value='Ever' />Ever</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at 1st use:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAgeat_9' name='txtAgeat_9' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtLastuse_9' name='txtLastuse_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Mild = 2 - 3, Moderate = 4 -5, Severe = 6 or more symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mode of use (include amount):</span></td>
                        <td className='w-375'><span className='eleHeader'>Frequency:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtamount_9' name='txtamount_9' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtFreq_9' name='txtFreq_9' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Route:</span>
                    <textarea placeholder='[CHOOSE ONE}' id='txtRoute_9' name='txtRoute_9' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_1' name='cbOTHERunknown_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' />Used in the past 12 months? (if checked, answer below):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_2' name='cbOTHERunknown_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended	' />Substance is often taken in larger amounts or over a longer period than intended</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_3' name='cbOTHERunknown_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' />Persistent desire or unsuccessful efforts to cut down or control use of substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_4' name='cbOTHERunknown_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' />Great deal of time used to obtain and/or recover from its effects</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_5' name='cbOTHERunknown_5' className='add-only' value='Craving, or strong desire or urge to use substance' />Craving, or strong desire or urge to use substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_6' name='cbOTHERunknown_6' className='add-only' value=' Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_7' name='cbOTHERunknown_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' />Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_8' name='cbOTHERunknown_8' className='add-only' value=' Important social, occupational, or recreational activities given up or reduced due to use' />Important social, occupational, or recreational activities given up or reduced due to use</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown_9' name='cbOTHERunknown_9' className='add-only' value=' Recurrent substance use in situations in which it is physically hazardous' />Recurrent substance use in situations in which it is physically hazardous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown__10' name='cbOTHERunknown__10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' />Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance	</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown__11' name='cbOTHERunknown__11' className='add-only' value=' Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' />Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOTHERunknown__12' name='cbOTHERunknown__12' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' />Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_28' name='txtAdditionalinformation_28' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>CAGE Questions</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbCAGE' name='cbCAGE' className='add-only' value='No History of Substance Use Reported' />No History of Substance Use Reported</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Have you ever felt you should cut down on your drinking/drug use?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbdrinking_No' name='rbdrinking' className='add-only' value='No' /> No </td>
                        <td className='w-250'><input type='radio' id='rbdrinking_Yes' name='rbdrinking' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Have people annoyed you by criticizing your drinking/drug use?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbdruguse_No' name='rbdruguse' className='add-only' value='No' /> No </td>
                        <td className='w-250'><input type='radio' id='rbdruguse_Yes' name='rbdruguse' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Have you ever felt bad/guilty about your drug use?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbfeltbad_No' name='rbfeltbad' className='add-only' value='No' /> No </td>
                        <td className='w-250'><input type='radio' id='rbfeltbad_Yes' name='rbfeltbad' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Have you ever had to drink/used drugs first thing in the morning to steady your nerves or help you to feel better?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbfeelbetter_No' name='rbfeelbetter' className='add-only' value='No' /> No </td>
                        <td className='w-250'><input type='radio' id='rbfeelbetter_Yes' name='rbfeelbetter' className='add-only' value='Yes' /> Yes </td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>To your knowledge, has your child ever overdosed or passed out on alcohol or other drugs?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rboverdosed_No' name='rboverdosed' className='add-only' value='No' /> No </td>
                        <td className='w-250'><input type='radio' id='rboverdosed_Yes' name='rboverdosed' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>when?</span>
                    <textarea id='txtwhen' name='txtwhen' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Have your child ever experienced problems related to their alcohol use?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbexperiencedproblems_No' name='rbexperiencedproblems' className='add-only' value='No' /> No </td>
                        <td className='w-250'><input type='radio' id='rbexperiencedproblems_Yes' name='rbexperiencedproblems' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>If yes, please check area and describe problems:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbdescribeproblems_1' name='cbdescribeproblems_1' className='add-only' value='Legal' />Legal</td>
                        <td className='w-250'><input type='checkbox' id='cbdescribeproblems_2' name='cbdescribeproblems_2' className='add-only' value='Social/Peer' />Social/Peer</td>
                        <td className='w-250'><input type='checkbox' id='cbdescribeproblems_3' name='cbdescribeproblems_3' className='add-only' value='Work' />Work</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbdescribeproblems_4' name='cbdescribeproblems_4' className='add-only' value='Family' />Family</td>
                        <td className='w-250'><input type='checkbox' id='cbdescribeproblems_5' name='cbdescribeproblems_5' className='add-only' value='Friends' />Friends</td>
                        <td className='w-250'><input type='checkbox' id='cbdescribeproblems_6' name='cbdescribeproblems_6' className='add-only' value='Financial' />Financial</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Please describe:</span>
                    <textarea id='txtPleasedescribe_14' name='txtPleasedescribe_14' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_29' name='txtAdditionalinformation_29' className='add-only'></textarea>
                </p>

                <h2>TREATMENT HISTORY</h2>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbTREATMENT' name='cbTREATMENT' className='add-only' value='No History of Substance Use Reported' />No History of Substance Use Reported</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>TREATMENT HISTORY</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Outpatient Treatment</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'><span className='eleHeader'>No</span></td>
                        <td className='w-50'><span className='eleHeader'>Yes</span></td>
                        <td className='w-200'><span className='eleHeader'>Where</span></td>
                        <td className='w-200'><span className='eleHeader'>When</span></td>
                        <td className='w-220'><span className='eleHeader'>How long</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <center><input type='radio' id='rbNoo_1No' name='rbNoo_1' className='add-only' /></center> </td>
                        <td className='w-50'> <center><input type='radio' id='rbYess_1Yes' name='rbYess_1' className='add-only' /></center> </td>
                        <td className='w-200'> <input type='text' id='txtWheree_1' name='txtWheree_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtWhenn_1' name='txtWhenn_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowlongg_1' name='txtHowlongg_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Inpatient Treatment</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'><span className='eleHeader'>No</span></td>
                        <td className='w-50'><span className='eleHeader'>Yes</span></td>
                        <td className='w-200'><span className='eleHeader'>Where</span></td>
                        <td className='w-200'><span className='eleHeader'>When</span></td>
                        <td className='w-220'><span className='eleHeader'>How long</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'><center> <input type='radio' id='rbNoo_2No' name='rbNoo_2' className='add-only' /></center> </td>
                        <td className='w-50'> <center><input type='radio' id='rbYess_2Yes' name='rbYess_2' className='add-only' /></center> </td>
                        <td className='w-200'> <input type='text' id='txtWheree_2' name='txtWheree_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtWhenn_2' name='txtWhenn_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowlongg_2' name='txtHowlongg_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Detox Unit</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'><span className='eleHeader'>No</span></td>
                        <td className='w-50'><span className='eleHeader'>Yes</span></td>
                        <td className='w-200'><span className='eleHeader'>Where</span></td>
                        <td className='w-200'><span className='eleHeader'>When</span></td>
                        <td className='w-220'><span className='eleHeader'>How long</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'><center> <input type='radio' id='rbNoo_3No' name='rbNoo_3' className='add-only' /> </center></td>
                        <td className='w-50'> <center><input type='radio' id='rbYess_3Yes' name='rbYess_3' className='add-only' /> </center></td>
                        <td className='w-200'> <input type='text' id='txtWheree_3' name='txtWheree_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtWhenn_3' name='txtWhenn_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowlongg_3' name='txtHowlongg_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>AA/NA/CA, etc.</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'><span className='eleHeader'>No</span></td>
                        <td className='w-50'><span className='eleHeader'>Yes</span></td>
                        <td className='w-200'><span className='eleHeader'>Where</span></td>
                        <td className='w-200'><span className='eleHeader'>When</span></td>
                        <td className='w-220'><span className='eleHeader'>How long</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <center> <input type='radio' id='rbNoo_4No' name='rbNoo_4' className='add-only' /></center> </td>
                        <td className='w-50'> <center><input type='radio' id='rbYess_4Yes' name='rbYess_4' className='add-only' /></center> </td>
                        <td className='w-200'> <input type='text' id='txtWheree_4' name='txtWheree_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtWhenn_4' name='txtWhenn_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowlongg_4' name='txtHowlongg_4' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Do you have a sponsor</span></td>
                        <td className='w-375'><span className='eleHeader'>Name & Phone Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>  <input type='radio' id='rbNoo_5No' name='rbNoo_5' className='add-only' value='No' />NO </td>
                        <td className='w-187'> <input type='radio' id='rbYess_5Yes' name='rbYess_5' className='add-only' value='Yes' />Yes</td>
                        <td className='w-375'> <input type='text' id='txtWheree_5' name='txtWheree_5' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_30' name='txtAdditionalinformation_30' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>How do you feel about your substance use (get quote)?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbsubstanceuse' name='cbsubstanceuse' className='add-only' value='No History of Substance Use Reported' />No History of Substance Use Reported</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Client insight to substance use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbClientinsightto_1' name='cbClientinsightto_1' className='add-only' value='Good' />Good</td>
                        <td className='w-250'><input type='checkbox' id='cbClientinsightto_2' name='cbClientinsightto_2' className='add-only' value='Fair' />Fair</td>
                        <td className='w-250'><input type='checkbox' id='cbClientinsightto_3' name='cbClientinsightto_3' className='add-only' value='Poor' />Poor</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>
                </p>

                <tr>
                    <td className='w-750'><span className='eleHeader'>Clinical focus based on observation of client's insight level (choose one):</span></td>
                </tr>
                <tr>
                    <td className='w-750'><input type='checkbox' id='cbClinicalfocus_1' name='cbClinicalfocus_1' className='add-only' value='Engagement (client unaware of any problem)' />Engagement (client unaware of any problem)</td>
                </tr>
                <tr>
                    <td className='w-750'><input type='checkbox' id='cbClinicalfocus_2' name='cbClinicalfocus_2' className='add-only' value='Persuasion (client thinks they may have a problem)' />Persuasion (client thinks they may have a problem)</td>
                </tr>
                <tr>
                    <td className='w-750'><input type='checkbox' id='cbClinicalfocus_3' name='cbClinicalfocus_3' className='add-only' value='Active Treatment (client aware of problem)' />Active Treatment (client aware of problem)</td>
                </tr>
                <tr>
                    <td className='w-750'><input type='checkbox' id='cbClinicalfocus_4' name='cbClinicalfocus_4' className='add-only' value='Relapse Prevention (Client focuses on sober strategies)' />Relapse Prevention (Client focuses on sober strategies)</td>
                </tr>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_31' name='txtAdditionalinformation_31' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>LEGAL INVOLVEMENT</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbLEGALINVOLVEMENT' name='cbLEGALINVOLVEMENT' className='add-only' value='No Legal System Involvement Reported' />No Legal System Involvement Reported</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Is there a current custody case involving your child? </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbcurrentcustody_No' name='rbcurrentcustody' className='add-only' value='No' /> No </td>
                        <td className='w-250'><input type='radio' id='rcurrentcustody_Yes' name='rbcurrentcustody' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>please describe:</span>
                    <textarea id='txtpleasedescribe_3' name='txtpleasedescribe_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Children Family Services (CFS) involvement:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFamilyServices_1' name='cbFamilyServices_1' className='add-only' value='None ' />None </td>
                        <td className='w-187'><input type='checkbox' id='cbFamilyServices_2' name='cbFamilyServices_2' className='add-only' value='Past' />Past </td>
                        <td className='w-187'><input type='checkbox' id='cbFamilyServices_3' name='cbFamilyServices_3' className='add-only' value='Current: ' />Current: </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <textarea id='txtCurrent' name='txtCurrent' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Please indicate by checking your child's legal status below:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cblegalstatus_1' name='cblegalstatus_1' className='add-only' value='No involvement' />No involvement</td>
                        <td className='w-250'><input type='checkbox' id='cblegalstatus_2' name='cblegalstatus_2' className='add-only' value='Charges Pending' />Charges Pending </td>
                        <td className='w-250'><input type='checkbox' id='cblegalstatus_3' name='cblegalstatus_3' className='add-only' value='Prior incarceration ' />Prior incarceration </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cblegalstatus_4' name='cblegalstatus_4' className='add-only' value=' Probation/length:' /> Probation/length:</td>
                        <td className='w-250'><input type='checkbox' id='cblegalstatus_5' name='cblegalstatus_5' className='add-only' value='Parole/length:' />Parole/length: </td>
                        <td className='w-250'><input type='checkbox' id='cblegalstatus_6' name='cblegalstatus_6' className='add-only' value='Prior incarceration ' />Lawsuit: </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtProbation' name='txtProbation' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtParole' name='txtParole' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLawsuit' name='txtLawsuit' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cblegalstatus_6' name='cblegalstatus_6' className='add-only' value='Other Court proceeding: ' />Other Court proceeding:</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtproceeding' name='txtproceeding' className='add-only' /> </td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Charges:</span>
                    <textarea id='txtCharges' name='txtCharges' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>  Probation/Parole Officer's name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Phone number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtParoleOfficer' name='txtParoleOfficer' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtPhonenumber' name='txtPhonenumber' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_32' name='txtAdditionalinformation_32' className='add-only'></textarea>
                </p>

                <h2>HISTORY OF ABUSE/NEGLECT</h2>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has your child ever been abused or assaulted ?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbbeenabused_No' name='rbbeenabused' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbbeenabused_Yes' name='rbbeenabused' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    please complete the chart below
                </p>


                <table>
                    <tr>
                        <td className='w-187'><span className='eleHeader'> Type of abuse</span></td>
                        <td className='w-250'><span className='eleHeader'>By whom?</span></td>
                        <td className='w-130'><span className='eleHeader'>At what age?</span></td>
                        <td className='w-180'><span className='eleHeader'>Was it reported?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_1' name='cbTypeofabuse_1' className='add-only' value='Sexual ' />Sexual</td>
                        <td className='w-250'><input type='text' id='txtBywhom_1' name='txtBywhom_1' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_1' name='txtAtwhatage_1' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_1No' name='rbWasitreported_1' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_1Yes' name='rbWasitreported_1' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_2' name='cbTypeofabuse_2' className='add-only' value='Physical' />Physical</td>
                        <td className='w-250'><input type='text' id='txtBywhom_2' name='txtBywhom_2' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_2' name='txtAtwhatage_2' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_2No' name='rbWasitreported_2' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_2Yes' name='rbWasitreported_2' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_3' name='cbTypeofabuse_3' className='add-only' value='Emotional' />Emotional</td>
                        <td className='w-250'><input type='text' id='txtBywhom_3' name='txtBywhom_3' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_3' name='txtAtwhatage_3' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_3No' name='rbWasitreported_3' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_3Yes' name='rbWasitreported_3' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_4' name='cbTypeofabuse_4' className='add-only' value='Verbal' />Verbal</td>
                        <td className='w-250'><input type='text' id='txtBywhom_4' name='txtBywhom_4' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_4' name='txtAtwhatage_4' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_4No' name='rbWasitreported_4' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_4Yes' name='rbWasitreported_4' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_5' name='cbTypeofabuse_5' className='add-only' value='Abandoned/Neglected' />Abandoned/Neglected </td>
                        <td className='w-250'><input type='text' id='txtBywhom_5' name='txtBywhom_5' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_5' name='txtAtwhatage_5' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_5No' name='rbWasitreported_5' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_5Yes' name='rbWasitreported_5' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_33' name='txtAdditionalinformation_33' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has your child ever been a victim of bullying?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='radio' id='rbbullying_No' name='rbbullying' className='add-only' value='No' /> No </td>
                        <td className='w-375'> <input type='radio' id='rbbullying_Yes' name='rbbullying' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>please describe: </span>
                    <textarea id='txtpleasedescribe_4' name='txtpleasedescribe_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Do you worry about your child's safety now?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='radio' id='rbsafety_No' name='rbsafety' className='add-only' value='No' /> No </td>
                        <td className='w-375'> <input type='radio' id='rbsafety_Yes' name='rbsafety' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>please describe: </span>
                    <textarea id='txtpleasedescribe_5' name='txtpleasedescribe_5' className='add-only'></textarea>

                    <span className='eleHeader'>What else do you feel/believe is important for us to know?</span>
                    <textarea id='txtbelieveisimportant' name='txtbelieveisimportant' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_34' name='txtAdditionalinformation_34' className='add-only'></textarea>
                </p>


                <h2>HISTORY OF VIOLENCE</h2>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has your child ever been accused of abusing or assaulting someone?  </span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbassaultingsomeone_No' name='rbassaultingsomeone' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbassaultingsomeone_Yes' name='rbassaultingsomeone' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>

                <p className='w-750'>
                    please complete the chart below
                </p>

                <table>
                    <tr>
                        <td className='w-187'><span className='eleHeader'> Type of abuse</span></td>
                        <td className='w-250'><span className='eleHeader'>By whom?</span></td>
                        <td className='w-130'><span className='eleHeader'>At what age?</span></td>
                        <td className='w-180'><span className='eleHeader'>Was it reported?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_6' name='cbTypeofabuse_6' className='add-only' value='Sexual ' />Sexual</td>
                        <td className='w-250'><input type='text' id='txtBywhom_6' name='txtBywhom_6' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_6' name='txtAtwhatage_6' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_6No' name='rbWasitreported_6' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_6Yes' name='rbWasitreported_6' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_7' name='cbTypeofabuse_7' className='add-only' value='Physical' />Physical</td>
                        <td className='w-250'><input type='text' id='txtBywhom_7' name='txtBywhom_7' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_7' name='txtAtwhatage_7' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_7No' name='rbWasitreported_7' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_7Yes' name='rbWasitreported_7' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_8' name='cbTypeofabuse_8' className='add-only' value='Emotional' />Emotional</td>
                        <td className='w-250'><input type='text' id='txtBywhom_8' name='txtBywhom_8' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_8' name='txtAtwhatage_8' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported__8No' name='rbWasitreported_8' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported__8Yes' name='rbWasitreported_8' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_9' name='cbTypeofabuse_9' className='add-only' value='Verbal' />Verbal</td>
                        <td className='w-250'><input type='text' id='txtBywhom_9' name='txtBywhom_9' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_9' name='txtAtwhatage_9' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_9No' name='rbWasitreported_9' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_9Yes' name='rbWasitreported_9' className='add-only' value='Yes' /> Yes </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTypeofabuse_10' name='cbTypeofabuse_10' className='add-only' value='Abandoned/Neglected' />Abandoned/Neglected </td>
                        <td className='w-250'><input type='text' id='txtBywhom_10' name='txtBywhom_10' className='add-only' /></td>
                        <td className='w-130'><input type='text' id='txtAtwhatage_10' name='txtAtwhatage_10' className='add-only' /> </td>
                        <td className='w-90'><input type='radio' id='rbWasitreported_10No' name='rbWasitreported_10' className='add-only' value='No' /> No </td>
                        <td className='w-90'> <input type='radio' id='rbWasitreported_10Yes' name='rbWasitreported_10' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_35' name='txtAdditionalinformation_35' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has your child ever been known to bully other children?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbbullyother_No' name='rbbullyother' className='add-only' value='No' /> No </td>
                        <td className='w-187'> <input type='radio' id='rbbullyother_Yes' name='rbbullyother' className='add-only' value='Yes' /> Yes </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>please describe: </span>
                    <textarea id='txtpleasedescribe_6' name='txtpleasedescribe_6' className='add-only'></textarea>

                    <span className='eleHeader'>What else do you feel/believe is important for us to know?</span>
                    <textarea id='txtyoufeel' name='txtyoufeel' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_36' name='txtAdditionalinformation_36' className='add-only'></textarea>
                </p>


                <h2>PSYCHIATRIC CHECKLIST</h2>
                <p className='w-750'>
                    <b>INATTENTION/HYPERACTIVITY/IMPULSIVITY</b> <br />
                    <b>Inattention</b>
                </p>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_1' name='cbCurrent_1' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_1' name='cbPast_1' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_1' name='ccbNever_1' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Often fails to give close attention to details or makes mistakes in schoolwork, work, or other activities </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_2' name='cbCurrent_2' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_2' name='cbPast_2' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_2' name='ccbNever_2' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Often has difficulty sustaining attention in tasks or play activities</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_3' name='cbCurrent_3' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_3' name='cbPast_3' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_3' name='ccbNever_3' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often does not listen when spoken to directly</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_4' name='cbCurrent_4' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_4' name='cbPast_4' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_4' name='ccbNever_4' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Often does not follow through on instructions and fails to finish schoolwork, chores, or duties in the workplace [not due to failure to understand instructions]</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_5' name='cbCurrent_5' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_5' name='cbPast_5' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_5' name='ccbNever_5' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often has difficulty organizing tasks and activities</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_6' name='cbCurrent_6' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_6' name='cbPast_6' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_6' name='ccbNever_6' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often loses things necessary for tasks or activities [e.g. Pens, books or tools]</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_7' name='cbCurrent_7' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_7' name='cbPast_7' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_7' name='ccbNever_7' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often avoids, dislikes or is reluctant to engage in tasks that require sustained mental effort [such as school or coursework]</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_8' name='cbCurrent_8' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_8' name='cbPast_8' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_8' name='ccbNever_8' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Is often distracted by extraneous stimuli</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_9' name='cbCurrent_9' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_9' name='cbPast_9' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_9' name='ccbNever_9' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Is often forgetful in daily activities</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_1' name='txttheybeenhappening_1' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_37' name='txtAdditionalinformation_37' className='add-only'></textarea>

                    <b>Hyperactivity</b>
                </p>


                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_10' name='cbCurrent_10' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_10' name='cbPast_10' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_10' name='ccbNever_10' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often fidgets with hands or feet, or squirms in seat</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_11' name='cbCurrent_11' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_11' name='cbPast_11' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_11' name='ccbNever_11' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Often leaves seat in classroom or other situations in which remaining seated is expected</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_12' name='cbCurrent_12' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_12' name='ccbNever_12' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_12' name='ccbNever_12' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Often runs about or climbs excessively [or has feelings of restlessness]</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_13' name='cbCurrent_13' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_13' name='cbPast_13' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_13' name='ccbNever_13' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Often has difficulty playing or engaging in leisure activities quietly</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_14' name='cbCurrent_14' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_14' name='cbPacbPast_14st_1cbPast_14' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_14' name='ccbNever_14' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Is often on the go or often acts as if 'driven by a motor'</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_15' name='cbCurrent_15' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_15' name='cbPast_15' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_15' name='ccbNever_15' className='add-only' value='' /></center> </td>
                        <td className='w-575'>  Often talks excessively</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_2' name='txttheybeenhappening_2' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_38' name='txtAdditionalinformation_38' className='add-only'></textarea>

                    <b>Impulsivity</b>
                </p>


                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_16' name='cbCurrent_16' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_16' name='cbPast_16' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_16' name='ccbNever_16' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Often blurts out answers before questions have been completed</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_17' name='cbCurrent_17' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_17' name='cbPast_17' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_17' name='ccbNever_17' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Often has difficulty awaiting turn</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_18' name='cbCurrent_18' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_18' name='cbPast_18' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_18' name='ccbNever_18' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Often interrupts or intrudes on others</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_3' name='txttheybeenhappening_3' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_39' name='txtAdditionalinformation_39' className='add-only'></textarea>
                </p>

                <h2>MOOD</h2>
                <p className='w-750'> <b>Disruptive Behaviors</b></p>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_19' name='cbCurrent_19' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_19' name='cbPast_19' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_19' name='ccbNever_19' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Severe recurrent temper outbursts manifested verbally (e.g., verbal rages) and/or behaviorally (e.g., physical aggression toward people or property) that are grossly out of proportion in intensity or duration to the situation or provocation</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_20' name='cbCurrent_20' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_20' name='cbPast_20' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_20' name='ccbNever_20' className='add-only' value='' /> </center></td>
                        <td className='w-575'>The temper outbursts are inconsistent with developmental level.</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_21' name='cbCurrent_21' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_21' name='cbPast_21' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_21' name='ccbNever_21' className='add-only' value='' /></center></td>
                        <td className='w-575'> The temper outbursts occur, on average, three or more times per week</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_22' name='cbCurrent_22' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_22' name='cbPast_22' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_22' name='ccbNever_22' className='add-only' value='' /></center> </td>
                        <td className='w-575'>The mood between temper outbursts in persistently irritable or angry most of the day, nearly every day, and is observable by others (e.g., parents, teachers, peers).</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_4' name='txttheybeenhappening_4' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_40' name='txtAdditionalinformation_40' className='add-only'></textarea>
                </p>

                <h2>Depression</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_23' name='cbCurrent_23' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_23' name='cbPast_23' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_23' name='ccbNever_23' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Depressed mood or irritable most of the day, nearly every day, as indicated by either subjective report (e.g., feels sad or empty) or observation made by others (e.g., appears tearful). </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_24' name='cbCurrent_24' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_24' name='cbPast_24' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_24' name='ccbNever_24' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Decreased interest or pleasure in most activities, most of each day</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_25' name='cbCurrent_25' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_25' name='cbPast_25' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_25' name='ccbNever_25' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Significant weight change (5%) or change in appetite</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_26' name='cbCurrent_26' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_26' name='cbPast_26' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_26' name='ccbNever_26' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Change in sleep: Insomnia or hypersomnia.</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_27' name='cbCurrent_27' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_27' name='cbPast_27' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_27' name='ccbNever_27' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Change in activity: Psychomotor agitation or retardation</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_28' name='cbCurrent_28' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_28' name='cbPast_28' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_28' name='ccbNever_28' className='add-only' value='' /></center></td>
                        <td className='w-575'>Fatigue or loss of energy</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_29' name='cbCurrent_29' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_29' name='cbPast_29' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_29' name='ccbNever_29' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Guilt/worthlessness: Feelings of worthlessness or excessive or inappropriate guilt</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_30' name='cbCurrent_30' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbCurrent_30' name='cbCurrent_30' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_30' name='ccbNever_30' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Concentration: diminished ability to think or concentrate, or more indecisiveness</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_31' name='cbCurrent_31' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbCurrent_31' name='cbCurrent_31' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_31' name='ccbNever_31' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Suicidality: Thoughts of death or suicide, or has suicide plan</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_5' name='txttheybeenhappening_5' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_41' name='txtAdditionalinformation_41' className='add-only'></textarea>
                </p>

                <h2>Mania/Hypomania</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_32' name='cbCurrent_32' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_32' name='cbPast_32' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_32' name='ccbNever_32' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Very high self-esteem/grandiosity? (Ever feel super confident or think you have special powers or could be famous?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_33' name='cbCurrent_33' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_33' name='cbPast_33' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_33' name='ccbNever_33' className='add-only' value='' /> </center></td>
                        <td className='w-575'>More talkative? (Have people had trouble interrupting you?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_34' name='cbCurrent_34' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_34' name='cbPast_34' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_34' name='ccbNever_34' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Racing thoughts? (Have thoughts come to you very easily and quickly?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_35' name='cbCurrent_35' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_35' name='cbPast_35' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_35' name='ccbNever_35' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Distractibility? (Could any little thing get you off track from what you were thinking of doing?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_36' name='cbCurrent_36' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_36' name='cbPast_36' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_36' name='ccbNever_36' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Increase in goal directed activity? (Were you more active or energetic than usual?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_37' name='cbCurrent_37' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_37' name='cbPast_37' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_37' name='ccbNever_37' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Risky behavior? (Did you spend lots of unplanned money, drive faster than usual, or do anything else risky/dangerous?)</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_6' name='txttheybeenhappening_6' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_42' name='txtAdditionalinformation_42' className='add-only'></textarea>
                </p>

                <h2>SEPARATION/ANXIETY/PANIC/TRAUMA</h2>

                <p className='w-750'><b>Separation</b></p>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_38' name='cbCurrent_38' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_38' name='cbPast_38' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_38' name='ccbNever_38' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Recurrent excessive distress when anticipating or experiencing separation from home or from major attachment figures</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_39' name='cbCurrent_39' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_39' name='cbPast_39' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_39' name='ccbNever_39' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Persistent and excessive worry about losing major attachment figures or about possible harm to them, such as illness, injury, disasters, or death</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_40' name='cbCurrent_40' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_40' name='cbPast_40' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_40' name='ccbNever_40' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Persistent and excessive worry about experiencing an untoward event (eg, getting lost, being kidnapped, having an accident, becoming ill) that causes separation from a major attachment figure</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_41' name='cbCurrent_41' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_41' name='cbPast_41' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_41' name='ccbNever_41' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Reluctance or refusal to go out, away from home, to school, to work, or elsewhere because of fear of separation</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_42' name='cbCurrent_42' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_42' name='cbPast_42' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_42' name='ccbNever_42' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Excessive fear of or reluctance about being alone or without major attachment figures at home or in other settings</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_43' name='cbCurrent_43' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_43' name='cbPast_43' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_43' name='ccbNever_43' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Reluctance or refusal to sleep away from home or to go to sleep without being near a major attachment figure</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_44' name='cbCurrent_44' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_44' name='cbPast_44' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_44' name='ccbNever_44' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Repeated nightmares involving the theme of separation</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_45' name='cbCurrent_45' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_45' name='cbPast_45' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_45' name='cbPast_45' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Repeated complaints of physical symptoms (e.g., headaches, stomachaches, nausea, vomiting) when separation from major attachment figures occurs or is anticipated</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_7' name='txttheybeenhappening_7' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_43' name='txtAdditionalinformation_43' className='add-only'></textarea>
                </p>

                <h2> Anxiety</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_46' name='cbCurrent_46' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_46' name='cbPast_46' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_46' name='ccbNever_46' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Excessive anxiety and worry (apprehensive expectation) about a number of events or activities (such as work or school performance)? For how long?</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_47' name='cbCurrent_47' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_47' name='cbPast_47' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_47' name='ccbNever_47' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Difficult to control the worry</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_47' name='cbCurrent_47' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_47' name='cbPast_47' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_47' name='ccbNever_47' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Restlessness, feeling keyed up or on edge</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_48' name='cbCurrent_48' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_48' name='cbPast_48' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_48' name='ccbNever_48' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Being easily fatigued</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_49' name='cbCurrent_49' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_49' name='cbPast_49' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_49' name='ccbNever_49' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Difficulty concentrating or mind going blank</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_50' name='cbCurrent_50' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_50' name='cbPast_50' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_50' name='ccbNever_50' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Irritability</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_51' name='cbCurrent_51' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_51' name='cbPast_51' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_51' name='ccbNever_51' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Muscle tension </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_52' name='cbCurrent_52' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_52' name='cbPast_52' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_52' name='cbPast_52' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Sleep disturbance (difficulty falling or staying asleep, or restless, unsatisfying sleep)</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_8' name='txttheybeenhappening_8' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_44' name='txtAdditionalinformation_44' className='add-only'></textarea>
                </p>

                <h2>Panic</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_53' name='cbCurrent_53' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_53' name='cbPast_53' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_53' name='ccbNever_53' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Palpitations, pounding heart, or accelerated heart rate</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_54' name='cbCurrent_54' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_54' name='cbPast_54' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_54' name='ccbNever_54' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Sweating</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_55' name='cbCurrent_55' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_55' name='cbPast_55' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_55' name='ccbNever_55' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Trembling or shaking</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_56' name='cbCurrent_56' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_56' name='cbPast_56' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_56' name='ccbNever_56' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Sensations of shortness of breath or smothering</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_57' name='cbCurrent_57' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_57' name='cbPast_57' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_57' name='ccbNever_57' className='add-only' value='' /></center> </td>
                        <td className='w-575'>A feeling of choking</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_58' name='cbCurrent_58' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_58' name='cbPast_58' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_58' name='ccbNever_58' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Chest pain or discomfort</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_59' name='cbCurrent_59' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_59' name='cbPast_59' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_59' name='ccbNever_59' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Nausea or abdominal distress</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_60' name='cbCurrent_60' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_60' name='cbPast_60' className='add-only' value='' /></center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_60' name='ccbNever_60' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Feeling dizzy, unsteady, light-headed, or faint</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_61' name='cbCurrent_61' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_61' name='cbPast_61' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_61' name='ccbNever_61' className='add-only' value='' /> </center></td>
                        <td className='w-575'> Chills or heat sensations</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_62' name='cbCurrent_62' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_62' name='cbPast_62' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_62' name='ccbNever_62' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Paresthesia (numbness or tingling sensations)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_63' name='cbCurrent_63' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_63' name='cbPast_63' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_63' name='ccbNever_63' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Derealization (feelings of unreality) or depersonalization (being detached from oneself)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_64' name='cbCurrent_64' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_64' name='cbPast_64' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_64' name='ccbNever_64' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Fear of losing control or â€œgoing crazy</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_65' name='cbCurrent_65' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_65' name='cbPast_65' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_65' name='ccbNever_65' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Fear of dying</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_9' name='txttheybeenhappening_9' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_45' name='txtAdditionalinformation_45' className='add-only'></textarea>
                </p>

                <h2>Trauma</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_66' name='cbCurrent_66' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_66' name='cbPast_66' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_66' name='ccbNever_66' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Witnessed extremely traumatic event involving actual or threatened death or serious injury and intense fear/helplessness/or horror? Or Learning that a traumatic event occurred to a family member or close friend? Or experienced repeated or extreme exposure to aversive details of the traumatic event?</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What did you witness?</span>
                    <textarea id='txtWhatdidyouwitness' name='txtWhatdidyouwitness' className='add-only'></textarea>

                    <span className='eleHeader'>How did you react?</span>
                    <textarea id='txtHowdidyoureact' name='txtHowdidyoureact' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_46' name='txtAdditionalinformation_46' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_67' name='cbCurrent_67' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_67' name='cbPast_67' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_67' name='ccbNever_67' className='add-only' value='' /></center> </td>
                        <td className='w-575'><u>Intrusion</u> (associated with the event, beginning after the event occurred):</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_68' name='cbCurrent_68' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_68' name='cbPast_68' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_68' name='ccbNever_68' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Recurrent, involuntary, and intrusive distressing memories of traumatic event(s)
                            0 </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_69' name='cbCurrent_69' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_69' name='cbPast_69' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_69' name='ccbNever_69' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Recurrent distressing dreams in which the content and/or affect of the dream are related to the traumatic event(s)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_70' name='cbCurrent_70' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_70' name='cbPast_70' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_70' name='ccbNever_70' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Dissociative reactions (Flashbacks)? Do you ever feel as if it is happening again?</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_71' name='cbCurrent_71' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_71' name='cbPast_71' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_71' name='ccbNever_71' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Intense or prolonged psychological distress at exposure to internal or external sues that symbolize or resemble an aspect of the traumatic event(s)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_72' name='cbCurrent_72' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_72' name='cbPast_72' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_72' name='ccbNever_72' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Physical reactivity (Do reminders make you sweat, tremble, shortness of breath, racing heart? Marked physiological reactions to internal or external cues that symbolize or resemble an aspect of the traumatic event(s))</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <span className='small'>(have they happened longer than one month?) </span>
                    <textarea id='txttheybeenhappening_10' name='txttheybeenhappening_10' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_47' name='txtAdditionalinformation_47' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_73' name='cbCurrent_73' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_73' name='cbPast_73' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_73' name='ccbNever_73' className='add-only' value='' /> </center></td>
                        <td className='w-575'><u>Avoidance</u> (of stimuli associate with the event, beginning after the event occurred):</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_74' name='cbCurrent_74' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_74' name='cbPast_74' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_74' name='ccbNever_74' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Avoidance of or efforts to avoid distressing memories, thoughts, memories of the traumatic event</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_75' name='cbCurrent_75' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_75' name='cbPast_75' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_75' name='ccbNever_75' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Avoidance of or efforts to avoid external reminders (

                            <input type='checkbox' id='cbExtReminder_1' name='cbExtReminder_1' className='add-only' value='ExtReminder_1' /> people, &nbsp;
                            <input type='checkbox' id='cbExtReminder_2' name='cbExtReminder_2' className='add-only' value='ExtReminder_2' /> places,&nbsp;
                            <input type='checkbox' id='cbExtReminder_3' name='cbExtReminder_3' className='add-only' value='ExtReminder_3' /> conversations,&nbsp;
                            <input type='checkbox' id='cbExtReminder_4' name='cbExtReminder_4' className='add-only' value='ExtReminder_4' /> activities,&nbsp;
                            <input type='checkbox' id='cbExtReminder_5' name='cbExtReminder_5' className='add-only' value='ExtReminder_5' /> objects,&nbsp;
                            <input type='checkbox' id='cbExtReminder_6' name='cbExtReminder_6' className='add-only' value='ExtReminder_6' /> situations)

                            that arouse distressing memories, thoughts, or feelings about or closely associated with the traumatic event(s)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <span className='small'>(have they happened longer than one month?) </span>
                    <textarea id='txttheybeenhappening_11' name='txttheybeenhappening_11' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_48' name='txtAdditionalinformation_48' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_78' name='cbCurrent_78' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_78' name='cbPast_78' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_78' name='ccbNever_78' className='add-only' value='' /> </center></td>
                        <td className='w-575'><u>Negative altercations in cognitions and mood</u> (associated with the event, beginning after the event(s) occurred):</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_79' name='cbCurrent_79' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_79' name='cbPast_79' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_79' name='ccbNever_79' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Inability to remember an important aspect of the traumatic event (s)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_80' name='cbCurrent_80' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_80' name='cbPast_80' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='ccbNever_80' name='ccbNever_80' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Persistent and exaggerated negative beliefs or expectations about oneself, others, or the world</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_81' name='cbCurrent_81' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_81' name='cbPast_81' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_81' name='cbNever_81' className='add-only' value='' /> </center></td>
                        <td className='w-575'>Persistent, distorted cognitions about the cause or consequences of the traumatic event(s) that lead the individual to blame self/others</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_82' name='cbCurrent_82' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_82' name='cbPast_82' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_82' name='cbNever_82' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Persistent negative emotional state (e.g. fear, horror, guilt, or shame)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_83' name='cbCurrent_83' className='add-only' value='' /> </center></td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_83' name='cbPast_83' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_83' name='cbNever_83' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Markedly diminished interest or participation in significant activities</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_86' name='cbCurrent_86' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_86' name='cbPast_86' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_86' name='cbNever_86' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Feelings of detachment or estrangement from others</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_87' name='cbCurrent_87' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_87' name='cbPast_87' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_87' name='cbNever_87' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Persistent inability to experience positive emotions</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <span className='small'>(have they happened longer than one month?) </span>
                    <textarea id='txttheybeenhappening_12' name='txttheybeenhappening_12' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_49' name='txtAdditionalinformation_49' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_88' name='cbCurrent_88' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_88' name='cbPast_88' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_88' name='cbNever_88' className='add-only' value='' /></center> </td>
                        <td className='w-575'><u>Hyperarousal</u> (marked alterations in arousal and reactivity associated with the traumatic event(s):</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_89' name='cbCurrent_89' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_89' name='cbPast_89' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_89' name='cbNever_89' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Irritable behavior and angry outbursts (with little or no provocation) typically expressed as verbal and physical aggression toward people or objects</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_90' name='cbCurrent_90' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_90' name='cbPast_90' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_90' name='cbNever_90' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Reckless or self-destructive behavior</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_91' name='cbCurrent_91' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_91' name='cbPast_91' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_91' name='cbNever_91' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Hypervigilance (Are you now always on the alert for trouble?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_92' name='cbCurrent_92' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_92' name='cbPast_92' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_92' name='cbNever_92' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Exaggerated startle (Are you jumpy and easily startled by ordinary noise?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_93' name='cbCurrent_93' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_93' name='cbPast_93' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_93' name='cbNever_93' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Problems with concentration</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_94' name='cbCurrent_94' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_94' name='cbPast_94' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_94' name='cbNever_94' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Sleep disturbance (e.g. difficulty falling or staying asleep or restless sleep)</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <span className='small'>(have they happened longer than one month?) </span>
                    <textarea id='txttheybeenhappening_13' name='txttheybeenhappening_13' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_50' name='txtAdditionalinformation_50' className='add-only'></textarea>

                    <span className='eleHeader'>Does the disturbance cause clinically significant distress or impairment in social, occupational, or other important areas of functioning?</span>
                    <textarea id='txtdisturbance' name='txtdisturbance' className='add-only'></textarea>
                </p>

                <h2>OPPOSITIONAL/CONDUCT BEHAVIORS</h2>

                <p className='w-750'> <b>Angry/Irritable Mood</b> </p>


                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_95' name='cbCurrent_95' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_95' name='cbPast_95' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_95' name='cbNever_95' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Often loses temper</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_96' name='cbCurrent_96' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_96' name='cbPast_96' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_96' name='cbNever_96' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Is often touchy or easily annoyed</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_97' name='cbCurrent_97' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_97' name='cbPast_97' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_97' name='cbNever_97' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Is often angry and resentful</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_14' name='txttheybeenhappening_13' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_51' name='txtAdditionalinformation_50' className='add-only'></textarea>
                </p>

                <h2>Argumentative/Defiant Behavior</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_98' name='cbCurrent_98' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_98' name='cbPast_98' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_98' name='cbNever_98' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Argues with authority figures or with adults</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_99' name='cbCurrent_99' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_99' name='cbPast_99' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_99' name='cbNever_99' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Actively defies or refuses to comply with requests from authority figures or with rules</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_100' name='cbCurrent_100' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_100' name='cbPast_100' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_100' name='cbNever_100' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Deliberately annoys other</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_101' name='cbCurrent_101' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_101' name='cbPast_101' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_101' name='cbNever_101' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Blames others for his or her mistakes of behaviors</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_15' name='txttheybeenhappening_15' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_52' name='txtAdditionalinformation_50' className='add-only'></textarea>
                </p>

                <h2>Vindictiveness</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_102' name='cbCurrent_102' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_102' name='cbPast_102' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_102' name='cbNever_102' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has been spiteful or vindictive </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_16' name='txttheybeenhappening_16' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_53' name='txtAdditionalinformation_53' className='add-only'></textarea>
                </p>

                <h2> Aggression to People and Animals</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_103' name='cbCurrent_103' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_103' name='cbPast_103' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_103' name='cbNever_103' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often bullies, threatens, or intimidates others </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_104' name='cbCurrent_104' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_104' name='cbPast_104' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_104' name='cbNever_104' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often initiates physical fights</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_105' name='cbCurrent_105' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_105' name='cbPast_105' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_105' name='cbNever_105' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has used a weapon that can cause serious physical harm to others (e.g., a bat, brick, broken bottle, knife, gun)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_106' name='cbCurrent_106' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_106' name='cbPast_106' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_106' name='cbNever_106' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Has been physically cruel to people </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_107' name='cbCurrent_107' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_107' name='cbPast_107' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_107' name='cbNever_107' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has been physically cruel to animals</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_108' name='cbCurrent_108' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_108' name='cbPast_108' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_108' name='cbNever_108' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has stolen while confronting a victim (e.g. mugging, purse snatching, extortion, armed robbery)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_109' name='cbCurrent_109' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_109' name='cbPast_109' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_109' name='cbNever_109' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has forced someone into sexual activity </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_17' name='txttheybeenhappening_17' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_54' name='txtAdditionalinformation_54' className='add-only'></textarea>
                </p>

                <h2>Destruction of Property</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_110' name='cbCurrent_110' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_110' name='cbPast_110' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_110' name='cbNever_110' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has deliberately engaged in fire setting with the intention of causing serious damage</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_111' name='cbCurrent_111' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_111' name='cbPast_111' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_111' name='cbNever_111' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has deliberately destroyed others' property (other than by fire setting)</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_18' name='txttheybeenhappening_18' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_55' name='txtAdditionalinformation_55' className='add-only'></textarea>
                </p>

                <h2> Deceitfulness or Theft</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_112' name='cbCurrent_112' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_112' name='cbPast_112' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_112' name='cbNever_112' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has broken into someone else's house, building, or car</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_113' name='cbCurrent_113' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_113' name='cbPast_113' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_113' name='cbNever_113' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often lies to obtain goods or favors or to avoid obligations (i.e., â€œconsâ€ others)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_114' name='cbCurrent_114' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_114' name='cbPast_114' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_114' name='cbNever_114' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has stolen items of nontrivial value without confronting a victim (e.g., shoplifting, but without breaking and entering; forgery)</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_19' name='txttheybeenhappening_19' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_56' name='txtAdditionalinformation_56' className='add-only'></textarea>
                </p>

                <h2>Serious Violations of Rules</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_115' name='cbCurrent_115' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_115' name='cbPast_115' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_115' name='cbNever_115' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Often stays out at night despite parental prohibitions, beginning before age 13 years</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_116' name='cbCurrent_116' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_116' name='cbPast_116' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_116' name='cbNever_116' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Has run away from home overnight, or run away without returning for a lengthy period</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_117' name='cbCurrent_117' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_117' name='cbPast_117' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_117' name='cbNever_117' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Is often truant from school</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_20' name='txttheybeenhappening_20' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_57' name='txtAdditionalinformation_57' className='add-only'></textarea>
                </p>

                <h2>PSYCHOSIS</h2>
                <p className='w-750'><b>Hallucinations</b></p>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_118' name='cbCurrent_118' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_118' name='cbPast_118' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_118' name='cbNever_118' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Auditory hallucinations? (Do you ever hear sounds or voices that other people don't hear?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_119' name='cbCurrent_119' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_119' name='cbPast_119' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_119' name='cbNever_119' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Do you recognize the voices? Whose are they?</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_120' name='cbCurrent_120' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_120' name='cbPast_120' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_120' name='cbNever_120' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Command auditory hallucinations? (Do the voices tell you what to do?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_121' name='cbCurrent_121' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_121' name='cbPast_121' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_121' name='cbNever_121' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Violence? (Do the voices tell you to hurt yourself or anyone else?)</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What do they say? </span>
                    <textarea id='txtdotheysay_1' name='txtdotheysay_1' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_58' name='txtAdditionalinformation_58' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_122' name='cbCurrent_122' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_122' name='cbPast_122' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_122' name='cbNever_122' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Visual hallucinations? (Do you ever see visions or things that other people don't see?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_123' name='cbCurrent_123' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_123' name='cbPast_123' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_123' name='cbNever_123' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Tactile hallucinations? (Do you ever notice strange sensations in your body or on your skin?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_124' name='cbCurrent_124' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_124' name='cbPast_124' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_124' name='cbNever_124' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Olfactory hallucinations? (Do you ever smell odors no one else can smell?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_125' name='cbCurrent_125' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_125' name='cbPast_125' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_125' name='cbNever_125' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Paranoia? (Do you ever feel like someone or something is out to get you or hurt you?)</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Who? </span>
                    <textarea id='txtwho_1' name='txtwho_1' className='add-only'></textarea>
                    <span className='eleHeader'>Why? </span>
                    <textarea id='txtwhy_1' name='txtwhy_1' className='add-only'></textarea>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_21' name='txttheybeenhappening_21' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_59' name='txtAdditionalinformation_59' className='add-only'></textarea>
                </p>

                <h2>Delusions</h2>


                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_126' name='cbCurrent_126' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_126' name='cbPast_126' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_126' name='cbNever_126' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Thought insertion? (Do you ever have thoughts that were put in your head by someone else or other force?)
                        </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_127' name='cbCurrent_127' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_127' name='cbPast_127' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_127' name='cbNever_127' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Thought withdrawal? (Does someone or something ever take your thoughts out of your head?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_128' name='cbCurrent_128' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_128' name='cbPast_128' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_128' name='cbNever_128' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Ideas or reference? (Does the tv or radio ever give you special messages? Do you ever feel like strangers on the street are talking about you? Do you ever get special signs from things around you?)</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_129' name='cbCurrent_129' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_129' name='cbPast_129' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_129' name='cbNever_129' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Belief that you have exceptional abilities, wealth, fame</td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_130' name='cbCurrent_130' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_130' name='cbPast_130' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_130' name='cbNever_130' className='add-only' value='' /></center> </td>
                        <td className='w-575'>  Other:<input type='text' id='txtOther_1' name='txtOther_1' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_60' name='txtAdditionalinformation_60' className='add-only'></textarea>
                </p>

                <h2> Miscellaneous:</h2>

                <table>
                    <tr>
                        <td className='w-70'><span className='eleHeader'>Current</span></td>
                        <td className='w-50'><span className='eleHeader'>Past</span></td>
                        <td className='w-50'><span className='eleHeader'>Never</span></td>
                        <td className='w-575'><span className='eleHeader'>Symptom</span></td>
                    </tr>
                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_131' name='cbCurrent_131' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_131' name='cbPast_131' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_131' name='cbNever_131' className='add-only' value='' /></center> </td>
                        <td className='w-575'>Vomiting/binging/laxative use (Ever done unusual or extreme things to lose weight?) </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_132' name='cbCurrent_132' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_132' name='cbPast_132' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_132' name='cbNever_132' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Addictive behaviors (Gambling, sexual, pornography, other)

                            <input type='checkbox' id='cbAddictivebehaviors_1' name='cbAddictivebehaviors_1' className='add-only' value='ExtReminder_1' />Enuresis &nbsp;
                            <input type='checkbox' id='cbAddictivebehaviors_2' name='cbAddictivebehaviors_2' className='add-only' value='ExtReminder_2' /> Encopresis&nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-70'><center><input type='checkbox' id='cbCurrent_133' name='cbCurrent_133' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbPast_133' name='cbPast_133' className='add-only' value='' /></center> </td>
                        <td className='w-50'><center><input type='checkbox' id='cbNever_133' name='cbNever_133' className='add-only' value='' /></center> </td>
                        <td className='w-575'> Sleep Problems:<input type='text' id='txtSleepProblems' name='txtSleepProblems' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long have they been happening? </span>
                    <textarea id='txttheybeenhappening_22' name='txttheybeenhappening_22' className='add-only'></textarea>

                    <span className='eleHeader'> Additional information:</span>
                    <textarea id='txtAdditionalinformation_61' name='txtAdditionalinformation_61' className='add-only'></textarea>
                </p>

                <h2>MENTAL STATUS EXAM</h2>
                <p className='w-750'><b> General Observations</b></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='Well-groomed' />Well-groomed</td>
                        <td className='w-250'><input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Unkept' />Unkept</td>
                        <td className='w-250'><input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='Disheveled' />Disheveled</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Build</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbBuild_1' name='cbBuild_1' className='add-only' value='Average' />Average</td>
                        <td className='w-250'><input type='checkbox' id='cbBuild_2' name='cbBuild_2' className='add-only' value='Thin' />Thin</td>
                        <td className='w-250'><input type='checkbox' id='cbBuild_3' name='cbBuild_3' className='add-only' value='Overweight' />Overweight</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Demeanor</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_1' name='cbDemeanor_1' className='add-only' value='Average' />Average</td>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_2' name='cbDemeanor_2' className='add-only' value='Hostile' />Hostile</td>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_3' name='cbDemeanor_3' className='add-only' value='Mistrustful' />Mistrustful</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_4' name='cbDemeanor_4' className='add-only' value='Withdrawn' />Withdrawn</td>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_5' name='cbDemeanor_5' className='add-only' value='Preoccupied' />Preoccupied</td>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_6' name='cbDemeanor_6' className='add-only' value='Demanding' />Demanding</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>  Eye Contact</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEyeContact_1' name='cbEyeContact_1' className='add-only' value='Average' />Average</td>
                        <td className='w-250'><input type='checkbox' id='cbEyeContact_2' name='cbEyeContact_2' className='add-only' value='Avoidant' />Avoidant</td>
                        <td className='w-250'><input type='checkbox' id='cbEyeContact_3' name='cbEyeContact_3' className='add-only' value='Intense' />Intense</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Activity</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbActivity_1' name='cbActivity_1' className='add-only' value='Average' />Average</td>
                        <td className='w-250'><input type='checkbox' id='cbActivity_2' name='cbActivity_2' className='add-only' value='Agitated' />Agitated</td>
                        <td className='w-250'><input type='checkbox' id='cbActivity_3' name='cbActivity_3' className='add-only' value='Slowed' />Slowed</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>  Speech</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Clear' />Clear</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Slurred' />Slurred</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Slowed' />Slowed</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Rapid' />Rapid</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Pressured' />Pressured</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_1' name='txtComments_1' className='add-only'></textarea>
                </p>
                <h2>Thought Content</h2>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Delusions</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_1' name='cbSpeech_1' className='add-only' value='None reported' />None reported</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_2' name='cbSpeech2' className='add-only' value='Grandiose' />Grandiose</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_3' name='cbDelusions_3' className='add-only' value='Persecutory' />Persecutory</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_4' name='cbDelusions_4' className='add-only' value='Somatic' />Somatic</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_5' name='cbDelusions_5' className='add-only' value='Bizarre' />Bizarre</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_6' name='cbDelusions_6' className='add-only' value='Nihilistic' />Nihilistic</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_7' name='cbDelusions_7' className='add-only' value='Religious' />Religious</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther_2' name='txtOther_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_25' name='cbOther_25' className='add-only' value='None reported' />None reported</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_26' name='cbOther_26' className='add-only' value='Autistic' />Autistic</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_27' name='cbOther_27' className='add-only' value='Obsessional' />Obsessional</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_28' name='cbOther_28' className='add-only' value='Phobic' />Phobic</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOther_29' name='cbOther_29' className='add-only' value='Guilty' />Guilty</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_30' name='cbOther_30' className='add-only' value='Preoccupied' />Preoccupied</td>
                        <td className='w-187'><input type='checkbox' id='cbOther_31' name='cbOther_31' className='add-only' value='Guarded' />Guarded</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOther_29' name='cbOther_29' className='add-only' value='Other:' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther_3' name='txtOther_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Self-Abuse</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_1' name='cbSelfAbuse_1' className='add-only' value='None reported' />None reported</td>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_2' name='cbSelfAbuse_2' className='add-only' value='Suicidal (assess lethality if present)' />Suicidal (assess lethality if present)</td>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_3' name='cbSelfAbuse_3' className='add-only' value='Intent' />Intent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_4' name='cbSelfAbuse_4' className='add-only' value='Self-mutilation:' />Self-mutilation:</td>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_5' name='cbSelfAbuse_5' className='add-only' value='Plan' />Plan</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtSelfmutilation' name='txtSelfmutilation' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Aggressive</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAggressive_1' name='cbAggressive_1' className='add-only' value='None reported' />None reported</td>
                        <td className='w-250'><input type='checkbox' id='cbAggressive_2' name='cbAggressive_2' className='add-only' value='Aggressive (assess lethality if present)' />Aggressive (assess lethality if present)</td>
                        <td className='w-250'><input type='checkbox' id='cbAggressive_3' name='cbAggressive_3' className='add-only' value='Intent' />Intent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAggressive_4' name='cbAggressive_4' className='add-only' value='Plan' />Plan</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_2' name='txtComments_2' className='add-only'></textarea>

                </p>

                <h2>Perception</h2>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Hallucinations</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_1' name='cbHallucinations_1' className='add-only' value='None reported' />None reported</td>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_2' name='cbHallucinations_2' className='add-only' value='Auditory' />Auditory</td>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_3' name='cbHallucinations_3' className='add-only' value='Visual' />Visual</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_4' name='cbHallucinations_4' className='add-only' value='Olfactory' />Olfactory</td>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_5' name='cbHallucinations_5' className='add-only' value='Gustatory' />Gustatory</td>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_6' name='cbHallucinations_6' className='add-only' value='Tactile' />Tactile</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther_4' name='txtOther_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOther_30' name='cbOther_30' className='add-only' value='Illusions' />Illusions</td>
                        <td className='w-250'><input type='checkbox' id='cbOther_31' name='cbOther_31' className='add-only' value='Depersonalization' />Depersonalization</td>
                        <td className='w-250'><input type='checkbox' id='cbOther_32' name='cbOther_32' className='add-only' value='Derealization' />Derealization</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_3' name='txtComments_3' className='add-only'></textarea>

                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Process</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_1' name='cbThoughtPro_1' className='add-only' value='Logical' />Logical</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_2' name='cbThoughtPro_2' className='add-only' value='Circumstantial' />Circumstantial</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_3' name='cbThoughtPro_3' className='add-only' value='Tangential' />Tangential</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_4' name='cbThoughtPro_4' className='add-only' value='Loose' />Loose</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_5' name='cbThoughtPro_5' className='add-only' value='Racing' />Racing</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_6' name='cbThoughtPro_6' className='add-only' value='Incoherent' />Incoherent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_7' name='cbThoughtPro_7' className='add-only' value='Concrete' />Concrete</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_8' name='cbThoughtPro_8' className='add-only' value='Blocked' />Blocked</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtPro_9' name='cbThoughtPro_9' className='add-only' value='Flight of Ideas' />Flight of Ideas</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_4' name='txtComments_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mood - How are you feeling today?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='Euthymic' />Euthymic</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Depressed' />Depressed</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_3' name='cbMood_3' className='add-only' value='Anxious' />Anxious</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Angry' />Loose</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Euphoric' />Euphoric</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Irritable' />Irritable</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Concrete' />Concrete</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Blocked' />Blocked</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Flight of Ideas' />Flight of Ideas</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_5' name='txtComments_5' className='add-only'></textarea>

                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Affect</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Full' />Full</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Constricted' />Constricted</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Flat' />Flat</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Inappropriate' />Inappropriate</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='Labile' />Labile</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_6' name='txtComments_6' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Behavior</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_1' name='cbBehavior_1' className='add-only' value='Cooperative' />Cooperative</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_2' name='cbBehavior_2' className='add-only' value='Resistant' />Resistant</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_3' name='cbBehavior_3' className='add-only' value='Agitated' />Agitated</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_4' name='cbBehavior_4' className='add-only' value='Impulsive' />Impulsive</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_5' name='cbBehavior_5' className='add-only' value='Over-sedated' />Over-sedated</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_6' name='cbBehavior_6' className='add-only' value='Assaultive' />Assaultive</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_7' name='cbBehavior_7' className='add-only' value='Aggressive' />Aggressive</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_8' name='cbBehavior_8' className='add-only' value='Hyperactive' />Hyperactive</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_9' name='cbBehavior_9' className='add-only' value='Restless' />Restless</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_10' name='cbBehavior_10' className='add-only' value='Loss of Interests' />Loss of Interests</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_11' name='cbBehavior_11' className='add-only' value='Anhedonia' />Anhedonia</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_12' name='cbBehavior_12' className='add-only' value='Akathisia' />Akathisia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_13' name='cbBehavior_13' className='add-only' value='Withdrawn' />Withdrawn</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_14' name='cbBehavior_14' className='add-only' value='Dystonia' />Dystonia</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_15' name='cbBehavior_15' className='add-only' value='Tardive Dyskinesia' />Tardive Dyskinesia</td>
                    </tr>



                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_7' name='txtComments_7' className='add-only'></textarea>
                </p>

                <h2>Cognition</h2>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Impairment of:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_1' name='cbImpairment_1' className='add-only' value='None reported' />None reported</td>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_2' name='cbImpairment_2' className='add-only' value='Orientation' />Orientation</td>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_3' name='cbImpairment_3' className='add-only' value='Memory' />Memory</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_4' name='cbImpairment_4' className='add-only' value='Attention/Concentration' />Attention/Concentration</td>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_5' name='cbImpairment_5' className='add-only' value='Ability to Abstract' />Ability to Abstract</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Intelligence Estimate:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_1' name='cbIntelligence_1' className='add-only' value='DD' />DD</td>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_2' name='cbIntelligence_2' className='add-only' value='Borderline' />Borderline</td>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_3' name='cbIntelligence_3' className='add-only' value='Average' />Average</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_4' name='cbIntelligence_4' className='add-only' value='Above Average' />Above Average</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_8' name='txtComments_8' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insight/Judgment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbJudgment_Good' name='rbJudgment' className='add-only' value='Good' /> Good</td>
                        <td className='w-250'><input type='radio' id='rbJudgment_Fair' name='rbJudgment' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-250'><input type='radio' id='rbJudgment_Poor' name='rbJudgment' className='add-only' value='Poor' /> Poor</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Comments:</span>
                    <textarea id='txtComments_9' name='txtComments_9' className='add-only'></textarea>

                    <span className='eleHeader'> Elaboration of Active/Current Mental Status Findings
                    </span>
                    <textarea id='txtElaboration' name='txtElaboration' className='add-only'></textarea>
                </p>

                <h2>NARRATIVE SUMMARY</h2>

                <p className='w-750'>
                    <span className='eleHeader'> Narrative Summary</span>
                    <span className='small'>Narrative Summary (Include etiology of presenting problem and maintenance of the problem; mental health history; SUD history; severity of problem; where problem occurs (functioning at home, at work, in community); onset of problem (acute vs. chronic); client motivation for treatment, whether problem is known to be responsive to treatment.)</span>
                    <textarea id='txtNarrative' name='txtNarrative' className='add-only'></textarea>
                </p>

                <h2>DIAGNOSTIC IMPRESSION</h2>

                <p className='w-750'>  <span className='eleHeader'>Diagnostic Impression </span>
                    <span className='small'>(DSM 5 diagnosis and ICD 10 Code): </span>
                    <textarea id='txtNarrative' name='txtNarrative' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>RECOMMENDED SERVICE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRECOMMENDED_1' name='cbRECOMMENDED_1' className='add-only' value='Diagnostic Evaluation' />Diagnostic Evaluation</td>
                    </tr>
                </table>
                <p className='w-750'>  <span className='small'> (Includes Initial Diagnostic Evaluation and Diagnostic Update) </span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRECOMMENDED_2' name='cbRECOMMENDED_2' className='add-only' value='CPST' />CPST</td>
                    </tr>
                </table>
                <p className='w-750'>  <span className='small'> Community Psychiatric Service Treatment</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRECOMMENDED_3' name='cbRECOMMENDED_3' className='add-only' value='IHBT' />IHBT</td>
                    </tr>
                </table>
                <p className='w-750'>  <span className='small'>Intensive Home-Based Treatment</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRECOMMENDED_4' name='cbRECOMMENDED_4' className='add-only' value='ACT' />ACT</td>
                    </tr>
                </table>
                <p className='w-750'>  <span className='small'>Assertive Community Treatment</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRECOMMENDED_5' name='cbRECOMMENDED_5' className='add-only' value='Psychoeducation Support Services' />Psychoeducation Support Services</td>
                    </tr>
                </table>
                <p className='w-750'>  <span className='small'>(Includes Psychosocial Service Rehabilitation, Therapeutic Behavioral Services - individual, families, groups, and crisis)  </span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRECOMMENDED_6' name='cbRECOMMENDED_6' className='add-only' value='Psychotherapy' />Psychotherapy</td>
                    </tr>
                </table>
                <p className='w-750'>  <span className='small'> (Includes Psychotherapy for individuals, families, groups, interactive complexity, and crisis)</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRECOMMENDED_7' name='cbRECOMMENDED_7' className='add-only' value='Substance Use Disorder Services*' />Substance Use Disorder Services*</td>
                    </tr>
                </table>
                <p className='w-750'>  <span className='small'>(Includes SUD Assessment; SUD Case Management; SUD Psychotherapy for individuals, groups, and families) Both client and parent must complete ASAM before placing in SUD services</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRECOMMENDED_8' name='cbRECOMMENDED_8' className='add-only' value='Med Management' />Med Management</td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> STRENGTHS/ASSETS/RESOURCES</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_1' name='cbSTRENGTHS_1' className='add-only' value='Strong support system' />Strong support system</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_2' name='cbSTRENGTHS_2' className='add-only' value='Self-confident' />Self-confident</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_3' name='cbSTRENGTHS_3' className='add-only' value='Decisive' />Decisive</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_4' name='cbSTRENGTHS_4' className='add-only' value='Flexible' />Flexible</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_5' name='cbSTRENGTHS_5' className='add-only' value='Survivor' />Survivor</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_6' name='cbSTRENGTHS_6' className='add-only' value='Resourceful' />Resourceful</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_7' name='cbSTRENGTHS_7' className='add-only' value='Team player' />Team player</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_8' name='cbSTRENGTHS_8' className='add-only' value='Independent' />Independent</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_9' name='cbSTRENGTHS_9' className='add-only' value='Respects self' />Respects self</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_10' name='cbSTRENGTHS_10' className='add-only' value='Good social skills' />Good social skills</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_11' name='cbSTRENGTHS_11' className='add-only' value='Insightful' />Insightful</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_12' name='cbSTRENGTHS_12' className='add-only' value='Committed' />Committed</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_13' name='cbSTRENGTHS_13' className='add-only' value='Compassionate' />Compassionate</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_14' name='cbSTRENGTHS_14' className='add-only' value='Transparent' />Transparent</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_15' name='cbSTRENGTHS_15' className='add-only' value='Educated' />Educated</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_16' name='cbSTRENGTHS_16' className='add-only' value='Intelligent' />Intelligent</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_17' name='cbSTRENGTHS_17' className='add-only' value='Logical' />Logical</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_18' name='cbSTRENGTHS_18' className='add-only' value='Caring' />Caring</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_19' name='cbSTRENGTHS_19' className='add-only' value='Sense of humor' />Sense of humor</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_20' name='cbSTRENGTHS_20' className='add-only' value=' Honest' /> Honest</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_21' name='cbSTRENGTHS_21' className='add-only' value='Resilient' />Resilient</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_22' name='cbSTRENGTHS_22' className='add-only' value='Organized' />Organized</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_23' name='cbSTRENGTHS_23' className='add-only' value='Internal strength' />Internal strength</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_24' name='cbSTRENGTHS_24' className='add-only' value='Curious' />Curious</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_25' name='cbSTRENGTHS_25' className='add-only' value='Goal-oriented' />Goal-oriented</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_26' name='cbSTRENGTHS_26' className='add-only' value='Strong-willed' />Strong-willed</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_27' name='cbSTRENGTHS_27' className='add-only' value='Can multi-task' />Can multi-task</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_28' name='cbSTRENGTHS_28' className='add-only' value='Diplomatic' />Diplomatic</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_29' name='cbSTRENGTHS_29' className='add-only' value='Employable' />Employable</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_30' name='cbSTRENGTHS_30' className='add-only' value='Emotional control' />Emotional control</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_31' name='cbSTRENGTHS_31' className='add-only' value='Self-sufficient' />Self-sufficient</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_32' name='cbSTRENGTHS_32' className='add-only' value='Creative' />Creative</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_33' name='cbSTRENGTHS_33' className='add-only' value='Enjoys learning new things' />Enjoys learning new things</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_34' name='cbSTRENGTHS_34' className='add-only' value='Disciplined' />Disciplined</td>
                        <td className='w-187'><input type='checkbox' id='cbSTRENGTHS_35' name='cbSTRENGTHS_35' className='add-only' value='Expressive' />Expressive</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> SKILLS DEFICITS/SKILLS TRAINING/COMMUNITY SUPPORT NEEDS </span>
                    <span className='small'>(check all applicable skills deficits, skills training, and/or community support needs identified)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSKILLSDEFICITS_1' name='cbSKILLSDEFICITS_1' className='add-only' value='Treatment planning. Participating in and utilizing strengths-based treatment/planning which may include assisting the individual and family members or other collaterals with identifying strengths and needs' />Treatment planning. Participating in and utilizing strengths-based treatment/planning which may include assisting the individual and family members or other collaterals with identifying strengths and needs</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSKILLSDEFICITS_2' name='cbSKILLSDEFICITS_2' className='add-only' value=' Identification of strategies or treatment options. Assisting the individual and family members or other collaterals to identify strategies or treatment options associated with the individuals mental illness.' /> Identification of strategies or treatment options. Assisting the individual and family members or other collaterals to identify strategies or treatment options associated with the individual's mental illness.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSKILLSDEFICITS_3' name='cbSKILLSDEFICITS_3' className='add-only' value='Crisis prevention and amelioration. Assisting the individual with effectively responding to or avoiding identified precursors or triggers that would risk their remaining in a community setting or that result in functional impairments, including assisting the individual and family members or other collaterals with identifying a potential psychiatric or personal crisis, developing a crisis management plan, and/or, as appropriate, seeking other supports to restore stability and functioning.' />Crisis prevention and amelioration. Assisting the individual with effectively responding to or avoiding identified precursors or triggers that would risk their remaining in a community setting or that result in functional impairments, including assisting the individual and family members or other collaterals with identifying a potential psychiatric or personal crisis, developing a crisis management plan, and/or, as appropriate, seeking other supports to restore stability and functioning.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSKILLSDEFICITS_4' name='cbSKILLSDEFICITS_4' className='add-only' value='Restoration of social skills. Rehabilitation and support with the restoration of social and interpersonal skills to increase community tenure enhance personal relationships, establish support networks, increase community awareness, develop coping strategies and promote effective functioning in the individuals social environment including home, work, and school.' />Restoration of social skills. Rehabilitation and support with the restoration of social and interpersonal skills to increase community tenure enhance personal relationships, establish support networks, increase community awareness, develop coping strategies and promote effective functioning in the individual's social environment including home, work, and school.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSKILLSDEFICITS_5' name='cbSKILLSDEFICITS_5' className='add-only' value='Restoration of daily functioning. Assisting the individual to restore daily functioning specific to managing their own home including managing their money, medications, and using community resources and other self-care requirements' />Restoration of daily functioning. Assisting the individual to restore daily functioning specific to managing their own home including managing their money, medications, and using community resources and other self-care requirements</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSKILLSDEFICITS_6' name='cbSKILLSDEFICITS_6' className='add-only' value='Developing and providing solution focused interventions and emotional and behavioral management drawn from evidence-based psychotherapeutic treatments' />Developing and providing solution focused interventions and emotional and behavioral management drawn from evidence-based psychotherapeutic treatments</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> As Evidenced By </span>
                    <span className='small'>(describe the specific skill deficits or areas where improvement is needed):</span>
                    <textarea id='txtEvidenced' name='txtEvidenced' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Evaluation Completed by:</span></td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Clinician Signature	</td>
                        <td className='small w-250'>Printed Name (with credentials) </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Supervisor Signature (if, applicable)</td>
                        <td className='small w-250'>Printed Name (with credentials)	 </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Client Name:</td>
                        <td className='small w-250'>DOB:</td>
                        <td className='small w-250'>MRN:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}